
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    if(!this.querySelector("input")) return
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
      if(!this.querySelector("input")) return
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
      if(!this.querySelector("input")) return
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if(event.target.name === "minus" && previousValue == 1){
     
      var removeBtn = event.target.closest('.cart-item').querySelector('.cart-item-remove-btn').click();
    }
  }

  validateQtyRules() {
      if(!this.querySelector("input")) return
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min) - 1;
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        // if (
        //   event.pointerType === "mouse" &&
        //   !event.target.closest("deferred-media, product-model")
        // )
        //   this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / (this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft));
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft * (this.slidesPerPage + 1) - this.sliderItemsToShow[0].offsetLeft;
    
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 0;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      // this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      // this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();
    this.slider.addEventListener('wheel', this.preventScroll.bind(this), { passive: false });
    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = false;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }
  
  preventScroll(event) {
    event.preventDefault();
  }
  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", function(event){
       this.onVariantChange(event)
    });
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.checkVariant(event);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo(event);
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  checkVariant(event) {
    let variantOriginalPrice = this.currentVariant?.price;
    let variantComparePrice = this.currentVariant?.compare_at_price;
    let calculateDiscount = Math.round(100 - (variantOriginalPrice / variantComparePrice * 100));
    var colorsLabelCheckt = event.target.closest('.swatches-wrapper').previousElementSibling;
    if(calculateDiscount > 0 && !isNaN(calculateDiscount)){      
     document.querySelectorAll('.discount-label').forEach(discountLabel => {
      discountLabel.innerHTML = `&nbsp;- ${calculateDiscount}% Off`;
    }) 
    }else{
      document.querySelectorAll('.discount-label').forEach(discountLabel => {
      discountLabel.innerHTML = '';
    }) 
    }
      const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
        const destinations = document.querySelectorAll(`#price-${this.dataset.section}`);


      if (destinations.length){
          destinations.forEach(destination => {
            const comparePrices = destination.querySelectorAll('.product-compare_prices')
            const normalPrices = destination.querySelectorAll('.product-normal_prices')
            if(comparePrices  && this.currentVariant?.compare_at_price > this.currentVariant?.price ){
              comparePrices?.forEach(price => {
              var priceValue = formatToIDR(this.currentVariant.compare_at_price / 100)
              price.textContent = priceValue
              })
              destination.querySelector('.price.price--large')?.classList.add('price--on-sale')
            }else{
              destination.querySelector('.price.price--large')?.classList.remove('price--on-sale')
            }
            if(normalPrices){
              normalPrices?.forEach(price => {
                 var priceValue = formatToIDR(this.currentVariant.price / 100)
              price.textContent = priceValue
              })
            }
          })
        } 
        function formatToIDR(amount) {
            return amount.toLocaleString('id-ID', {
                style: 'currency',
                currency: 'IDR',
              minimumFractionDigits: 0,
                maximumFractionDigits: 0
            });
        }
    
    
    
    
    if(event.target.closest('.product-form__input.color')){
     if(colorsLabelCheckt.classList.contains('core-swatches-label')){
        document.querySelector('.limited-swatches-label').querySelector('span.discount-label').innerHTML = '';
      }else if(colorsLabelCheckt.classList.contains('limited-swatches-label')){
        document.querySelector('.core-swatches-label').querySelector('span.discount-label').innerHTML = '';
      } 
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    const newUrl = this.dataset.url
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}${newUrl.includes('?') ? '&variant=' : '?variant=' }${this.currentVariant.id}`
    );
    window.current_variant = this.currentVariant
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
   
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    ); 
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const NotcoloroptionInputs = [
        ...option.querySelectorAll('input[type="radio"]:not([is-color-option]), option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked")?.value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      if(previousOptionSelected && availableOptionInputsValue){
      this.setInputAvailability(NotcoloroptionInputs, availableOptionInputsValue);
      }
    });
  }


  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo(event) {
    if(this.currentVariant.available){
      this.toggleAddButton( false, window.variantStrings.addToCart);
    } else{
      this.toggleAddButton( true, window.variantStrings.soldOut);
    }
    
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
   const view = this.dataset.view
        const destinations = document.querySelectorAll(`#price-${this.dataset.section}`);
    
    fetch(
      `${this.dataset.url}${(this.dataset.url).includes('?')  ? '&' : '?' }variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if ( this.currentVariant && this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`
        );

        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination)
          volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");
        
        // if (source && destination) destination.innerHTML = source.innerHTML;
      
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "hidden",
            skuSource.classList.contains("hidden")
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "hidden",
            pricePerItemSource.classList.contains("hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        // if (price) price.classList.remove("hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut,
          true,
          addButtonUpdated
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true, newButton) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text; 
         document.querySelector('.product-form__submit').classList.add('hidden');
    } else {
      addButton.removeAttribute("disabled");
         document.querySelector('.product-form__submit').classList.remove('hidden');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
    if(newButton){
      const colorGroup = newButton.getAttribute('data-color-group');
      const filterColor = newButton.getAttribute('data-filter-color');
      const currentColor = newButton.getAttribute('data-color');
      addButton?.setAttribute('data-color-group', colorGroup)
      addButton?.setAttribute('data-filter-color', filterColor)
      addButton?.setAttribute('data-color', currentColor)
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
    
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }
}

customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.variantData = null; // Initialize variantData to be null initially
  }

updateOptions() {
const fieldsets = Array.from(this.querySelectorAll("fieldset"));
const variantData = this.getVariantData();
let thisOptionFirstColor = this.querySelector('fieldset input[is-color-option]:checked');
document.querySelector('similar-product-items')?.setAttribute('data-color' , thisOptionFirstColor?.value)
document.querySelector('similar-product-items')?.setAttribute('data-color-group' , thisOptionFirstColor?.getAttribute('data-color-group'))
document.querySelector('related-product-items')?.setAttribute('data-color' , thisOptionFirstColor?.value)
document.querySelector('related-product-items')?.setAttribute('data-color-group' , thisOptionFirstColor?.getAttribute('data-color-group'))
window.refreshSimilarProducts()
 

// Collect all the radio buttons and related logic upfront
const radiosByFieldset = fieldsets.map((fieldset) => {
  const radios = Array.from(fieldset.querySelectorAll("input[type='radio']"));
  const selectedRadio = radios.find((radio) => radio.checked);
  const firstEnabledRadio = radios.find(input => {
    const availableColors = input.getAttribute('avalible-colors');
    return availableColors && availableColors.split(',').map(color => color.trim()).includes(thisOptionFirstColor?.value);
  });
  const firstAvailableRadio = radios.find(input => {
    const availableColors = input.getAttribute('avalible-colors');
    const Avalible = input.classList.contains('disabled');
    return availableColors && !Avalible && availableColors.split(',').map(color => color.trim()).includes(thisOptionFirstColor?.value);
  });

  // Determine all the radios that do not match the selected color
  const radiosNotIncludingValue = radios.filter(input => {
    const availableColors = input.getAttribute('avalible-colors');
    return availableColors && !availableColors.split(',').map(color => color.trim()).includes(thisOptionFirstColor?.value);
  });

  // Set visibility and hide unnecessary radios upfront
  radios.forEach(input => {
    const availableColors = input.getAttribute('avalible-colors');
    if (availableColors) {
      const isColorVisible = availableColors.split(',').map(color => color.trim()).includes(thisOptionFirstColor?.value);
      input.nextElementSibling?.classList.toggle('hidden', !isColorVisible);
    }
  });

  // Return the best available radio value
  if (selectedRadio) {
    return selectedRadio.value;
  } else if (firstAvailableRadio) {
    firstAvailableRadio.checked = true;
    return firstAvailableRadio.value;
  } else if (firstEnabledRadio) {
    firstEnabledRadio.checked = true;
    return firstEnabledRadio.value;
  } else {
    const firstRadio = radios[0];
    return firstRadio?.value;
  }
});

this.options = radiosByFieldset; 
}



  setInputAvailability(listOfOptions, listOfAvailableOptions) { 
      listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  getVariantData() {
    // This function retrieves and returns the variant data
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}



customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            cardProductAddToCartFunction();
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);




// aloyoga js --------


var screenWidth = screen.width;

// mega menu hover desktop
let items = document.querySelector(".header__inline-menu").querySelectorAll("details.mega-menu, details.dropdown-menu");
let simpleItems = document.querySelector(".header__inline-menu").querySelectorAll(".header__menu-item:not(summary)");

items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    simpleItems.forEach((simpleItem) => {
      simpleItem.style.opacity = "0.4";
    });

    items.forEach((sibling) => {
      if (sibling !== item) {
        sibling.removeAttribute("open");
        sibling.style.opacity = "0.4";
      }
    });

    item.style.opacity = "1";
    item.setAttribute("open", true);

    if (item.classList.contains("mega-menu")) {
      item.querySelector(".mega-menu__content").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
    } else {
      item.querySelector(".header__submenu").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
    }

    simpleItems.forEach((simpleItem) => {
      simpleItem.addEventListener("mouseover", () => {
        simpleItem.style.opacity = "1";
        item.removeAttribute("open", true);
        item.style.opacity = "0.4";
      });
      simpleItem.addEventListener("mouseleave", () => {
        item.style.opacity = "1";
      });
    });

    item.addEventListener("mouseleave", () => {
      item.style.opacity = "1";
      item.removeAttribute("open", true);
      items.forEach((sibling) => {
        if (sibling !== item) {
          sibling.style.opacity = "1";
        }
      });

      simpleItems.forEach((simpleItem) => {
        simpleItem.style.opacity = "1";
      });
    });
    var otherElements = document.querySelectorAll(".header__icons, .header__heading, .utility-bar");
    otherElements.forEach((otherElement) => {
      otherElement.addEventListener("mouseover", () => {
        item.removeAttribute("open");
      });
    });

    
  });
});

// mega menu hover desktop end

// mobile drawer menu
var mobileMainLinks = document.querySelectorAll(".menu-drawer__main-link");
if (mobileMainLinks) {
  mobileMainLinks.forEach((mobileMainLink) => {
    mobileMainLink.addEventListener("click", () => {
      mobileMainLinks.forEach((mobileLinkSibling) => {
        if (mobileLinkSibling !== mobileMainLink) {
          mobileLinkSibling.classList.remove("drawer-link-active");
        }
      });

      mobileMainLink.classList.add("drawer-link-active");
      var dataLink = mobileMainLink.getAttribute("data-mobile-link");
      var mobileImages = document.querySelectorAll(".mega-menu-image-wrapper");
      if (mobileImages) {
        mobileImages.forEach((mobileImage) => {
          var dataLinkImage = mobileImage.getAttribute("data-mobile-link");
          if (dataLinkImage == dataLink) {
            mobileImage.classList.remove("hidden");
          } else {
            mobileImage.classList.add("hidden");
          }
        });
      }
    });
  });
}

var menuDrawerImages = document.querySelectorAll(".menu-drawer-image");
if (menuDrawerImages) {
  menuDrawerImages.forEach((menuDrawerImage) => {
    menuDrawerImage.addEventListener("click", () => {
      var menuDrawerGrandchildsWrapper = menuDrawerImage.closest(".mega-menu-image-wrapper").querySelector(".menu-drawer__submenu-links");
      if (menuDrawerGrandchildsWrapper) {
        menuDrawerGrandchildsWrapper.classList.add("open");
      }
    });
  });
}

var sublinksCloseBtns = document.querySelectorAll(".menu-drawer__submenu-header");
if (sublinksCloseBtns) {
  sublinksCloseBtns.forEach((sublinksCloseBtn) => {
    sublinksCloseBtn.addEventListener("click", () => {
      sublinksCloseBtn.closest(".menu-drawer__submenu-links").classList.remove("open");
    });
  });
}

var menuDrawerClose = document.querySelector(".menu-drawer__header").querySelector(".icon-close");
var mainClose = document.querySelector(".header__icon--menu.header__icon--summary");
menuDrawerClose.addEventListener("click", () => {
  menuDrawerClose.closest("details").removeAttribute("open");
  document.querySelector("body").classList.remove("overflow-hidden");
  document.querySelector("body").classList.remove("overflow-hidden-mobile");
  document.querySelector("body").classList.remove("overflow-hidden-tablet");
  mainClose.setAttribute("aria-expanded", "false");
});
mainClose.addEventListener("click", () => {
  document.querySelector(".menu-drawer__submenu-links").classList.remove("open");
});


// recent searches
// function to save search queries in cookies
function saveSearch(){
  const searchInputDesk = document.querySelector('.header-search-desktop-input').value;
  if(searchInputDesk.length >= 6){
    // get existing search queries from cookies
    let searches = getSearchesFromCookies();
    // add the new search query to the array
    searches.push(searchInputDesk);
    searches = searches.slice(-4);
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 30);
    document.cookie = "searches=" + JSON.stringify(searches) + "; expires=" + expirationDate.toUTCString();
    // display updated list
    displaySearches(searches);
    // setTimeout(performSearch(searchInputDesk), 2000);
  }else{

  }
}

// function retrieve search queries from cookies
function getSearchesFromCookies(){
  const cookies = document.cookie;
  const cookieArray = cookies.split("; ");
  for(let i=0; i < cookieArray.length; i++){
    const cookie = cookieArray[i].split("=");
    if(cookie[0] === "searches"){
      return JSON.parse(cookie[1]);
    }
  }
  return [];
}


// function display search queries list
function displaySearches(searches){
  const searchList = document.getElementById('searchList');
  searchList.innerHTML = ''; // clear previous list items
  // add each search query as list item
  searches.forEach(search => {
    const listItem = document.createElement('li');
    listItem.innerHTML = `<span><a href="/search?q=${search}&options%5Bprefix%5D=last">${search}</a></span><button class="remove-search-btn d-flex align-items-center"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.00939 10L2.5 3.49061L3.49061 2.5L10 9.00939L16.5094 2.5L17.5 3.49061L10.9906 10L17.5 16.5094L16.5094 17.5L10 10.9906L3.49061 17.5L2.5 16.5094L9.00939 10Z" fill="currentColor"></path></svg></button>`;
    searchList.appendChild(listItem);
  })

  var searchRemoveBtns = document.querySelectorAll('.remove-search-btn');
  if(searchRemoveBtns){
    searchRemoveBtns.forEach(searchRemoveBtn => {
      searchRemoveBtn.addEventListener('click', () => {
        var searchToRemove = searchRemoveBtn.closest('li');
        searchList.removeChild(searchToRemove);
      })
    })
  }
  
}

// initial display of search queries on page load
const searches = getSearchesFromCookies();
displaySearches(searches);

document.querySelector('.clear-search-history').addEventListener('click', () => {
  document.querySelector('#searchList').innerHTML = '';
})

// searchbar

var headerSearchBtn = document.querySelectorAll(".header__icon--search");
if (headerSearchBtn) {
  headerSearchBtn.forEach((headerSearchBttn) => {
    headerSearchBttn.addEventListener("click", function () {
      document.querySelector(".header__inline-menu").classList.add("slide-out");
      document.querySelector(".header-search-bar:not(.menu-drawer-search-bar)").classList.add("is-open");
      headerSearchBttn.style.display = "none";

      setTimeout(function(){
        document.querySelector('.search-suggestions-wrapper').classList.remove('hidden');
        document.querySelector(".header-search-bar:not(.menu-drawer-search-bar)").querySelector('.search__input').focus();
      },300);

      headerSearchBttn.nextElementSibling.classList.remove('hidden');
      
      setTimeout(function(){
        headerSearchBttn.closest('details').setAttribute('open',true)
      },100)

    });
  });
}
var headerSearchBars = document.querySelectorAll('.header-search-bar');
if(headerSearchBars){

  headerSearchBars.forEach(headerSearchBar => {
    var headerSearchInput = headerSearchBar.querySelector('.search__input');
    headerSearchInput.addEventListener('input', () => {
      saveSearch();
      var headerSearchInputValue = headerSearchInput.value;
 
      if(headerSearchInputValue.length >= 1){
        document.querySelector('.search-suggestions-wrapper').classList.add('hidden');
      }else{
        document.querySelector('.search-suggestions-wrapper').classList.remove('hidden');
      }
    })
  })
}


var searchBars = document.querySelectorAll(".header-search-bar");
if (searchBars) {
  searchBars.forEach((searchBar) => {
    var searchCloseBtn = searchBar.querySelector(".search-modal__close-button");
    if (searchCloseBtn) {
      searchCloseBtn.addEventListener("click", () => {
        // .querySelector('.header__icon--search')

        if (screenWidth > 990) {
          var headerSearchBtn = searchCloseBtn.closest(".header-search-bar").previousElementSibling.querySelector(".header__icon--search");
        } else {
          var headerSearchBtn = document.querySelector(".header-drawer-search").querySelector(".header__icon--search");
        }
        

        headerSearchBtn.style.display = "block";
        document.querySelector(".header-search-bar:not(.menu-drawer-search-bar)").classList.remove("is-open");
        document.querySelector(".header__inline-menu").classList.remove("slide-out");
        document.querySelector('.search-suggestions-wrapper').classList.add('hidden')
      });
    }
  });

  document.querySelector('.close-search-mbl').addEventListener('click',()=>{
    document.querySelector('.mobile-close-search').click();
  })
  
}

var searchBarsDesk = document.querySelectorAll(".header__icons");
if (searchBarsDesk) {
  searchBarsDesk.forEach((searchBar) => {
    var searchCloseBtn = searchBar.querySelector(".search-modal__close-button");
    if (searchCloseBtn) {
      searchCloseBtn.addEventListener("click", () => {
        // .querySelector('.header__icon--search')
      
        searchCloseBtn.closest('details').setAttribute('open',true)

        searchCloseBtn.classList.add('hidden')
        var headerSearchBtn = searchCloseBtn.previousElementSibling;
        

        headerSearchBtn.style.display = "block";
        document.querySelector(".header-search-bar:not(.menu-drawer-search-bar)").classList.remove("is-open");
        document.querySelector(".header__inline-menu").classList.remove("slide-out");
        document.querySelector('.search-suggestions-wrapper').classList.add('hidden')
      });
    }
  });
}

var headerSearchResetBtns = document.querySelectorAll('button.reset__button.field__button');
if(headerSearchResetBtns){
  headerSearchResetBtns.forEach(headerSearchResetBtn => {
    headerSearchResetBtn.addEventListener('click', () => {
      headerSearchResetBtn.closest('form').querySelector('.search-suggestions-wrapper').classList.remove('hidden');
    })
  })
  
}




function closeNotify() {
  var keepShoppingbtns = document.querySelectorAll('.keep-shopping-btn');
  if(keepShoppingbtns){
    keepShoppingbtns.forEach(keepShoppingbtn => {
      keepShoppingbtn.addEventListener('click', (event) => {
        event.preventDefault();
        document.querySelector('.cart-notification').classList.remove('active');
          document.querySelector('.cart-notification__close').click();
        })
    })
  }
  
}
  var cartNotificationWrapper = document.querySelector('.cart-notification-wrapper');
    var cartNotification = document.querySelector('.cart-notification');
  var keepShoppingLink =  cartNotification.querySelector('.keep-shopping-btn');



     cartNotificationWrapper?.addEventListener('click', function(event) { 
        if (cartNotification?.classList?.contains('active')) {
              if (event.target === cartNotificationWrapper || event.target === keepShoppingLink) {
                cartNotification.classList.remove('active');
             
            } 
        }
    });


setTimeout(function(){
  var wishlistPagebtns = document.querySelectorAll('.wishlist-move-cart');
  if(wishlistPagebtns){
    wishlistPagebtns.forEach(wishlistPagebtn => {
      wishlistPagebtn.addEventListener('click', (event) => {
        wishlistPagebtn.textContent = 'Moving...';
        setTimeout(function(){
           var WsoldOut = document.querySelector('.wishlist-p-right h3').textContent;
            
          
            if(WsoldOut.includes('sold out')){
                    
                  }else{
          var cartNotification = document.querySelector('.cart-notification');  
                  cartNotification?.classList.add('active');
                  var wCardWrapper = event.target.closest(".wishlist-column");
          
                  var wImage = wCardWrapper.querySelector('.wishlist-top img').getAttribute('src');
                  var witemTitle = wCardWrapper.querySelector(".wihslist-meta a").textContent;
                  var wItemVariant = wCardWrapper.querySelector('.wishlist-variant').textContent.replaceAll(' ', '');
                  var wItemVariant = wItemVariant.split('/');
                 
                  var wItemColor = wCardWrapper.querySelector('.wishlist-variant').textContent;
                  var wdataCartBtn = document.querySelector(".cart-notification__header").getAttribute("data-cart-link");
                  var wdataShoppingBtn = document.querySelector(".cart-notification__header").getAttribute("data-shopping-link");
          
                  var product_data = `<div class="cart-notification-product__image small-hide global-media-settings">
                      <img src="${wImage} alt="" width="100" height="auto" loading="lazy">
                    </div>
                    <div>
                      <h3 class="cart-notification-product__name h4">${witemTitle}</h3>
                      <dl>
                        <div class="product-option">
                          <dt>Color:</dt>
                          <dd>${wItemVariant[1]}</dd>
                        </div>
                        <div class="product-option">
                          <dt>Size:</dt>
                          <dd>${wItemVariant[0]}</dd>
                        </div>
                      </dl>
                      <div class="cart-noitfication-links">
                        <a onclick="document.querySelector('.cart-notification__close').click()" href="javacript:void(0)" type="button" class="button-label keep-shopping-btn button button--secondary uppercase font-arquitecta">${wdataShoppingBtn}</a>
                        <a href="/cart" onclick="window.location.href='/cart'" id="cart-notification-button" class="button button--primary uppercase font-arquitecta">
                          ${wdataCartBtn}
                        </a>
                      </div>
                    </div>`;
          
                    document.querySelector(".cart-notification-product").innerHTML = product_data;

                    fetch(window.location.href)
                    .then(response => {
                      if (!response.ok) {
                        throw new Error('Network response was not ok ' + response.statusText);
                      }
                      return response.text();
                    })
                    .then(html => {
                      // Parse the fetched HTML and extract the content you want to update
                      const parser = new DOMParser();
                      const doc = parser.parseFromString(html, 'text/html');
                      const newContent = doc.getElementById('CartDrawer').innerHTML;
                      const newCount = doc.querySelector('.cart-count-bubble').innerHTML;
                    
                      // Update the content of the page without a full reload
                      document.getElementById('CartDrawer').innerHTML = newContent;
                      document.querySelector('.cart-count-bubble').innerHTML = newCount;
                    })
                    .catch(error => {
                      console.error('There was a problem with the fetch operation:', error);
                    });

                    var wproductRecommendationId = wishlistPagebtn.getAttribute('data-product_id');
                    var wrelatedIdHolder = document.querySelector('[data-related-id]');
                    if(wrelatedIdHolder){
                      wrelatedIdHolder.setAttribute('data-related-id',wproductRecommendationId);
                    }
                    

                    var wminiCartRecommendations = document.querySelector('.mini-cart-recommendations');
                    var wminiCartRecommendationsUrl = document.querySelector('.mini-cart-recommendations').getAttribute('data-url');
                    
                    // extract the existing product ID from the URL
                    let wurlPattern = /product_id=(\d+)/;
                    let wexistingProductId = wurlPattern.exec(wminiCartRecommendationsUrl)[1];
                    
                    // replace the existing product ID with the new one
                    wminiCartRecommendationsUrl = wminiCartRecommendationsUrl.replace(wexistingProductId, wproductRecommendationId);
                    
                    
                    document.querySelector('.mini-cart-recommendations').setAttribute('data-url',wminiCartRecommendationsUrl);

                    var wNewUrl = document.querySelector('.mini-cart-recommendations').getAttribute('data-url');
              
                    fetch(wNewUrl)
                    .then((response) => response.text())
                    .then((text) => {
                      const html = document.createElement("div");
                      html.innerHTML = text;
                      const recommendations = html.querySelector("product-recommendations");
            
                      if (recommendations && recommendations.innerHTML.trim().length) {
                        wminiCartRecommendations.innerHTML = recommendations.innerHTML;
                        cardProductAddToCartFunction();
                      }
            
                      if (
                        !wminiCartRecommendations.querySelector("slideshow-component") &&
                        wminiCartRecommendations.classList.contains("complementary-products")
                      ) {
                        wminiCartRecommendations.remove();
                      }
            
                      if (html.querySelector(".grid__item")) {
                        wminiCartRecommendations.classList.add("product-recommendations--loaded");
                      }
                    })
                    .catch((e) => {
                      console.error(e);
                    });
              
                  }
            
          },4000)
  
        
      })
    })
  }
},5000);

// pdp add to cart recommendations
var pdpATCBtn = document.querySelector('.product-form__submit');
if(pdpATCBtn){

  pdpATCBtn.addEventListener('click', () => {
    var colorValue = pdpATCBtn.getAttribute('data-color');
    var colorGroupValue = pdpATCBtn.getAttribute('data-color-group');
    var filterColorValue = pdpATCBtn.getAttribute('data-filter-color');
    var productType = pdpATCBtn.getAttribute('data-product-type');
    var miniCartRecommendations = document.querySelector('.mini-cart-recommendations');
    miniCartRecommendations?.setAttribute('data-color', colorValue)
    miniCartRecommendations?.setAttribute('data-color-group', colorGroupValue)
    miniCartRecommendations?.setAttribute('data-filter-color', filterColorValue)
    miniCartRecommendations?.setAttribute('data-product-type', productType)
    miniCartRecommendations?.refresh()
  })  
}




// quick add to cart
var cardProductAddToCartFunction = function (data) {
 
  const plpProductCards = document.querySelectorAll('.product-card-wrapper');
  if(plpProductCards){
    plpProductCards.forEach(plpProductCard => {
      var cardProductSwatches = plpProductCard.querySelectorAll('.card-product-swatch-button');
      if(cardProductSwatches){
        cardProductSwatches.forEach(cardProductSwatch => {          
          cardProductSwatch.addEventListener('click', (event) =>{
            event.preventDefault();

            cardProductSwatches.forEach((cardProductSwatchSibling) => {
              if (cardProductSwatchSibling !== cardProductSwatch) {
                cardProductSwatchSibling.classList.remove("active");
              }
            });

            cardProductSwatch.classList.add("active");

            var cardSwatchDiscount = cardProductSwatch.dataset.variantDiscount;
            var cardSwatchColor = cardProductSwatch.dataset.colorValue;
            var cardSwatchVariantImage = cardProductSwatch.dataset.variantImage;
            var cardSwatchColorVariantId = cardProductSwatch.dataset.variantId;
         
            plpProductCard.querySelector('.card-selected-color').innerHTML = cardSwatchColor;

            var cardProductQuickaddSizes = plpProductCard.querySelectorAll('.quickadd-btn');
            if(cardProductQuickaddSizes){
              cardProductQuickaddSizes.forEach(cardProductQuickaddSize => {
                cardProductQuickaddSize.setAttribute('data-color',cardSwatchColor);
                if(cardSwatchVariantImage != ''){
                  cardProductQuickaddSize.setAttribute('data-card-product-image-src',cardSwatchVariantImage);  
                }
                
              })
            }

            var thisDiscountBadge = cardProductSwatch.closest('.limited-products-main').querySelector('.card-discount-badge');
            if(cardSwatchDiscount && cardSwatchDiscount != '' && cardSwatchDiscount > 0){
              thisDiscountBadge.style.display = 'inline-block';
              if(thisDiscountBadge){
               
                thisDiscountBadge.querySelector('span').textContent = cardSwatchDiscount;
              }
            }else if(thisDiscountBadge){
              thisDiscountBadge.style.display = 'none';
            }

            var cardProductUrl = cardProductSwatch.getAttribute('href');
           var cardVariantUrl = cardProductUrl.includes('?variant=') 
                ? cardProductUrl.split('?variant=')[0] + cardSwatchColorVariantId
                : cardProductUrl.includes('?') 
                    ? cardProductUrl +  cardSwatchColorVariantId.replace('?', '&') 
                    : cardProductUrl +  cardSwatchColorVariantId;


            plpProductCard.querySelector('.card-product-link').setAttribute('href',cardVariantUrl)

            var getColorBadge = cardProductSwatch.getAttribute('data-color-tag');
            var getColorPrice = cardProductSwatch.getAttribute('data-variant-price');
            var getColorComparePrice = cardProductSwatch.getAttribute('data-card-variant-compare');
            if(getColorBadge != ''){
              plpProductCard.querySelector('.card-product-tags').innerHTML = `<span class="card-badge fw-700 uppercase">${getColorBadge}</span>`
            }else{
              plpProductCard.querySelector('.card-product-tags').innerHTML = '';
            }

            if(getColorComparePrice != ''){             
              plpProductCard.querySelector('.card-information').querySelector('.price__sale').style.display = 'block';
              plpProductCard.querySelector('.card-information').querySelector('.price__sale .price-item.price-item--regular').innerHTML = getColorComparePrice;
              plpProductCard.querySelector('.card-information').querySelector('.price__sale .price-item.price-item--sale.price-item--last').innerHTML = getColorPrice;
              
              plpProductCard.querySelector('.card-information').querySelector('.price__regular').style.display = 'none';
            }else{
              plpProductCard.querySelector('.card-information').querySelector('.price__sale').style.display = 'none';
              plpProductCard.querySelector('.card-information').querySelector('.price__regular').style.display = 'block';
            }
            
            plpProductCard.querySelector('.card-information').querySelector('.price__regular .price-item.price-item--regular').innerHTML = getColorPrice;


            // change product card images based on color selection
            var colorSku = cardProductSwatch.getAttribute('data-sku');
            var cardProductMediaImages = plpProductCard.querySelectorAll('.color-sku-img');
            if(cardProductMediaImages && colorSku != ''){
              let firstMatchedImageFound = false;
              cardProductMediaImages.forEach((cardProductMediaImage,index) => {
                var cardMediaUrl = cardProductMediaImage.getAttribute('data-media-url');
                if(cardMediaUrl.includes(colorSku)){
                  if(!firstMatchedImageFound){
                    plpProductCard.querySelector('.card-primary-image').classList.add('hidden');
                    cardProductMediaImage.classList.remove('hidden');
                    cardProductMediaImage.classList.add('matched-images');
                    firstMatchedImageFound = true;
                  }else{
                    cardProductMediaImage.classList.add('hidden');
                    cardProductMediaImage.classList.remove('matched-images');
                  }
                }else{
                  cardProductMediaImage.classList.add('hidden');
                  cardProductMediaImage.classList.remove('matched-images');
                }
              })
            }

             var matchedImages = plpProductCard.querySelector('.matched-images');
            if(matchedImages){
              matchedImages.addEventListener('mouseenter', () => {
             
                matchedImages.nextElementSibling.classList.remove('hidden');
              })
            }

          })
        })
      }
      
      // mobile quickadd trigger
      var quickAddTrigger = plpProductCard.querySelector('.mobile-quickadd-trigger');
      var mobileQuickAddSizesContainer = document.querySelector('.mobile-quick-add').querySelector('.mobile-quickadd-sizes');
      if(quickAddTrigger){
        quickAddTrigger.addEventListener('click', (event) => {
          document.querySelector('.mobile-quick-add-wrapper').classList.remove('hidden');
          document.querySelector('.mobile-quick-add').classList.add('visible');
          const cardWrapperProduct = event.target.closest(".product-card-wrapper");
          var getCardProductId = cardWrapperProduct.getAttribute('data-product-id');
          mobileQuickAddSizesContainer.innerHTML = plpProductCard.querySelector('.quickadd-size-btns').innerHTML;
          document.querySelector('.mobile-quick-add-wrapper').setAttribute('data-product-id',getCardProductId);

          var mobileQuickAddBtns = mobileQuickAddSizesContainer.querySelectorAll('.quickadd-btn');
          if(mobileQuickAddBtns){
            mobileQuickAddBtns.forEach(mobileQuickAddBtn => {
              mobileQuickAddBtn.addEventListener('click', () => {
              var mblBtnValue = mobileQuickAddBtn.getAttribute('data-size');
              var thisParentProductId = mobileQuickAddBtn.closest('.mobile-quick-add-wrapper').getAttribute('data-product-id');
             
              var targetProductCard = document.querySelector('.product-card-wrapper[data-product-id="'+thisParentProductId+'"]');
                  targetProductCard.querySelector('.quickadd-btn[data-size="'+mblBtnValue+'"]').click();
                setTimeout(function(){
                  document.querySelector('.quickadd-mobile-close').click();
                },500)
              })
            })
          }
          
        })
      }

      
      
    })
  }



  var cartNotificationWrapper = document.querySelector('.cart-notification-wrapper');
  var cartNotification = document.querySelector('.cart-notification');
  var keepShoppingLink =  cartNotification.querySelector('.keep-shopping-btn');

     cartNotificationWrapper.addEventListener('click', function(event) { 

        if (cartNotification?.classList?.contains('active')) {
              if (event.target === cartNotificationWrapper || event.target === keepShoppingLink) {

                cartNotification.classList.remove('active');
            } 
        }
    }); 
  // closeNotify()
    

  const quickAddButtons = document.querySelectorAll(".quickadd-btn");
  quickAddButtons.forEach((quickAddButton) => {
     quickAddButton.addEventListener("click", async (event) => {
      event.preventDefault(); 
      const targetElement = event.target.matches('.quickadd-btn') ? event.target : event.target.closest('.quickadd-btn');
      const sizeValue = quickAddButton.getAttribute("data-size");
      const colorValue = quickAddButton.getAttribute("data-color");
      const colorGroupValue = quickAddButton.getAttribute("data-color-group");
      const filterColorValue = quickAddButton.getAttribute("data-filter-color");
      const productType = quickAddButton.getAttribute("data-product-type");
      const cardWrapper = targetElement.closest(".product-card-wrapper");

      var productRecommendationId = cardWrapper.getAttribute('data-product-id');
      var relatedIdHolder = document.querySelector('[data-related-id]');
      if(relatedIdHolder){
        relatedIdHolder.setAttribute('data-related-id',productRecommendationId);
      }
      

      var miniCartRecommendationsUrl = document.querySelector('.mini-cart-recommendations');
      miniCartRecommendationsUrl?.setAttribute('data-color', colorValue)
      miniCartRecommendationsUrl?.setAttribute('data-color-group', colorGroupValue)
      miniCartRecommendationsUrl?.setAttribute('data-filter-color', filterColorValue)
      miniCartRecommendationsUrl?.setAttribute('data-product-type', productType)
      miniCartRecommendationsUrl?.refresh()
      
      let selectedValue = "";
      let activeColorElement = "";
      let selectedVariant = "";
      let selectedValueQty = "";
      let selectedValuePolicy = "";
      if (cardWrapper) {
        activeColorElement = cardWrapper.querySelector(".color-label.active-color");
        let selectedColor = "";
        let selectedColorOptionIndex = "";
          selectedColor = targetElement.getAttribute('data-color') || "";
          selectedColorOptionIndex = targetElement.getAttribute('data-size-position') == "1" ? 0 : 1 ;
        
        if (activeColorElement) {
          selectedColor = activeColorElement.getAttribute("data-color");
          selectedColorOptionIndex = activeColorElement.getAttribute("data-color-option-index");
        }
        if (selectedColor !== "" && sizeValue !== "") {
          selectedVariant = selectedColorOptionIndex == 1 ? selectedColor + " / " + sizeValue : sizeValue + " / " + selectedColor;
        } else if (selectedColor == "" && sizeValue !== "") {
          selectedVariant = sizeValue;
        } else {
          selectedVariant = selectedColor;
        }
        var hiddenSelect = cardWrapper.querySelector(".select-card-product");
    
        if (hiddenSelect) {
          const selectedOption = hiddenSelect.querySelector(`option[data-variant-title="${selectedVariant}"]`);
          if (selectedOption) {
            selectedValue = selectedOption.value;
            selectedValueQty = selectedOption.getAttribute("data-card-variant-qty");
            selectedValuePolicy = selectedOption.getAttribute("data-inventory-policy");
            targetElement.setAttribute('data-selected-variant-id', selectedOption.getAttribute('data-variant-id'))
          }
        }
      }
      let colorImg = "";

      if (quickAddButton.classList.contains("default-variant")) {
        colorImg = quickAddButton.getAttribute("data-card-product-image-src");
        const cardProductTitle = quickAddButton.getAttribute("data-product-title");
      } else {
        if (activeColorElement) {
          colorImg = activeColorElement.querySelector("img").getAttribute("src");
        } else {
          colorImg = quickAddButton.getAttribute("data-card-product-image-src");
        }
        const cardProductTitle = quickAddButton.getAttribute("data-product-title");
        if (selectedValueQty <= 0 && selectedValuePolicy != "continue") {
        } else {
        }
      }

      // Ajax Add to Cart
      let variantId = "";
      if (quickAddButton.classList.contains("default-variant")) {
        variantId = quickAddButton.getAttribute("data-selected-variant-id");
      } else {
        // variantId = selectedValue;
        variantId = quickAddButton.getAttribute("data-selected-variant-id");
      }
      const cartUrl = "/cart/add.js";
      try {
        const response = await fetch(cartUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: `id=${variantId}&quantity=1`,
        });
        const data = await response.json();

        setTimeout(() => {
          if (selectedValueQty > 0 && selectedValuePolicy == "continue") {
            const current_count = document.querySelector(".cart-count-bubble").querySelector("span:first-child").innerHTML;
            document.querySelector(".cart-count-bubble").querySelector.innerHTML = current_count;
            document.querySelector(".cart-count-bubble").querySelector("span:first-child").innerHTML = parseInt(current_count) + 1;
          }
          const current_count = document.querySelector(".cart-count-bubble").querySelector("span:first-child").innerHTML;
          document.querySelector(".cart-count-bubble").querySelector.innerHTML = current_count;
          document.querySelector(".cart-count-bubble").querySelector("span:first-child").innerHTML = parseInt(current_count) + 1;
          document.querySelector(".drawer__footer-cart-link").querySelector('span').innerHTML = parseInt(current_count) + 1;

          cardWrapper.querySelector(".quickadd-success").classList.remove("hidden");
          cardWrapper.querySelector(".quickadd-success").nextElementSibling.classList.add("hidden");
          cardWrapper.querySelector(".quickadd-size-btns").classList.add("hidden");

          setTimeout(() => {
            cardWrapper.querySelector(".quickadd-success").classList.add("hidden");
            cardWrapper.querySelector(".quickadd-success").nextElementSibling.classList.remove("hidden");
            cardWrapper.querySelector(".quickadd-size-btns").classList.remove("hidden");
          }, 2000);

          document.querySelector(".cart-notification").classList.add("active");
          // var itemImage = cardWrapper.querySelector();
          var itemTitle = cardWrapper.querySelector(".card__heading a").textContent;
          var dataCartBtn = document.querySelector(".cart-notification__header").getAttribute("data-cart-link");
          var dataShoppingBtn = document.querySelector(".cart-notification__header").getAttribute("data-shopping-link");

          var product_data = `<div class="cart-notification-product__image small-hide global-media-settings">
            <img src="${colorImg}" alt="" width="100" height="auto" loading="lazy">
          </div>
          <div>
            <h3 class="cart-notification-product__name h4">${itemTitle}</h3>
            <dl>
              <div class="product-option">
                <dt>Color:</dt>
                <dd>${colorValue}</dd>
              </div>
              <div class="product-option">
                <dt>Size:</dt>
                <dd>${sizeValue}</dd>
              </div>
            </dl>
            <div class="cart-noitfication-links">
              <a onclick="document.querySelector('.cart-notification__close').click()" href="javacript:void(0)" type="button" class="button-label keep-shopping-btn button button--secondary uppercase font-arquitecta">${dataShoppingBtn}</a>
              <a href="/cart" onclick="window.location.href='/cart'" id="cart-notification-button" class="button button--primary uppercase font-arquitecta">
                ${dataCartBtn}
              </a>
            </div>
          </div>`;

          document.querySelector(".cart-notification-product").innerHTML = product_data;

          // drawer update
          var cartDrawer = document.querySelector('cart-drawer');
          var  formData =  cartDrawer.querySelector('form').querySelector('tbody');
          var cartDrawerSubTotal =  cartDrawer.querySelector('.cart-drawer-items-total');
          if (cartDrawer){
            quickAddButton.setAttribute('aria-haspopup', 'dialog');
                fetch(`${routes.cart_url}?section_id=main-cart-items`)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  const sourceQty = html.querySelector('cart-items').querySelector('.cart-table-grid');
                  if (sourceQty && formData){
                   formData.innerHTML = sourceQty.innerHTML;
                    cartDrawer.querySelector('.drawer__footer').classList.remove('hidden')
                    cartDrawer.querySelector('#CartDrawer-Checkout').removeAttribute('disabled');
                  }else{
                    if(cartDrawer.querySelector('cart-drawer-items').classList.contains('is-empty')){
                      cartDrawer.querySelector('cart-drawer-items').classList.remove('is-empty');
                      cartDrawer.querySelector('.drawer__inner-empty').classList.add('hidden');
                    }
                    cartDrawer.querySelector('.drawer__footer').style.display = 'block';
                    var formBody = document.createElement('tbody');
                    cartDrawer.querySelector('form').append(formBody);

                  }
                })
                .catch((e) => {
                  console.error(e);
                });

              fetch(`${routes.cart_url}`)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  const sourceQty = html.querySelector('cart-items').querySelector('.cart-table-grid');
                  const sourceQtyTotals =  html.querySelector('.cart__footer-wrapper').querySelector('.cart-items-total');
                  
                  if (sourceQty && formData){
                    cartDrawerSubTotal.innerHTML = sourceQtyTotals.innerHTML;
                  }else{
                    if(cartDrawer.querySelector('cart-drawer-items').classList.contains('is-empty')){
                      cartDrawer.querySelector('cart-drawer-items').classList.remove('is-empty');
                      cartDrawer.querySelector('.drawer__inner-empty').classList.add('hidden');
                    }
                    var formBody = document.createElement('tbody');
                    cartDrawer.querySelector('form').append(formBody);

                  }

                })
                .catch((e) => {
                  console.error(e);
                });

          }
        }, 1000);
      } catch (error) {}
    });
  });
};

cardProductAddToCartFunction();

const updateCartDrawer = (cart) => {
  const $cartDrawer = document.getElementById("CartDrawer");
  const cartItemWrappers = $cartDrawer.querySelectorAll(".cart-item");
  if (cart) {
    cartItemWrappers.forEach((item, index) => {
      const existingCartItem = $cartDrawer.querySelector(
        `#${cartItemWrappers.id}`
      );
      const cartItemTemplate =
        cartItemWrappers[index % cartItemWrappers.length].cloneNode(true);
      const cartItem = cartItemTemplate.querySelector(".cart-item");
      // Append the cart item to the cart drawer

      if (existingCartItem) {
      } else {
        const newCartItem = document.createElement("tr");
        newCartItem.className = "cart-item";
        newCartItem.id = item.id;
        $cartDrawer.querySelector("tbody").appendChild(newCartItem);
      }
    });
  } else {
  }
};

// cart notification close
var cartNotifyClose = document.querySelector('.cart-notification__close');
if(cartNotifyClose){
  cartNotifyClose.addEventListener('click', () => {
    document.querySelector('body').classList.remove('overflow-hidden');
  })
}

var limitedColorsCounts = document.querySelector('.limited-product-colors')
  if(limitedColorsCounts){
    var limitedColorsCount = limitedColorsCounts.querySelectorAll('.options-labels').length;
    if(limitedColorsCount == 1){
      document.querySelector('.limited-swatches-label .colors-count').innerHTML = limitedColorsCount + ' Color';
    }else{
      document.querySelector('.limited-swatches-label .colors-count').innerHTML = limitedColorsCount + ' Colors';
    }
    if(limitedColorsCount == 0){
      document.querySelector('.limited-swatches-label').classList.add('hidden');
    }
  }
  
var coreColorsCounts = document.querySelector('.core-color-products')
if(coreColorsCounts){
  var coreColorsCount = coreColorsCounts.querySelectorAll('.options-labels').length;
  if(coreColorsCount == 1){
    document.querySelector('.core-swatches-label .colors-count').innerHTML = coreColorsCount + ' Color';
  }else{
   document.querySelector('.core-swatches-label .colors-count').innerHTML = coreColorsCount + ' Colors'; 
  }
}  

var modalSlider = document.querySelector('.inside-modal-gallery');
if(modalSlider){
  var modalSliderBtns = modalSlider.querySelectorAll('.slider-button');
  if(modalSliderBtns){
    modalSliderBtns.forEach(modalSliderBtn => {
      modalSliderBtn.addEventListener('click', () => {
        // if(modalSliderBtn.hasAttribute('disabled')){
        // }
        modalSliderBtn.removeAttribute('disabled');
        
      })
    })
  }
}


var pdpColorLabels = document.querySelectorAll('.pdp-color-label')
if(pdpColorLabels){
  pdpColorLabels.forEach(pdpColorLabel => {
    pdpColorLabel.addEventListener('click', () => {
      
      var pdpColorLabels = document.querySelectorAll('.option-color-label') || document.querySelectorAll('.pdp-color-label');
      if(window.location.href.includes('yss-7-8-high-waist-airbrush-legging')){
          pdpColorLabels = document.querySelectorAll('.option-color-label') || document.querySelectorAll('.pdp-color-label');
      }else{
          var languageLabel = document.getElementsByClassName("option-warna-label");
          if(languageLabel.length > 0) {
              pdpColorLabels = document.querySelectorAll('.option-warna-label') || document.querySelectorAll('.pdp-color-label');
          }
      }
      
      var optionsLanguageLabel = document.getElementsByClassName("warna-product-swatch-wrapper");
      pdpColorLabels.forEach(pdpColorLabelSibling => {
          if (pdpColorLabelSibling != pdpColorLabel) {
              pdpColorLabelSibling.querySelector('.color-product-swatch-wrapper').classList.remove('active');
              if(optionsLanguageLabel.length > 0) {
                   pdpColorLabelSibling.querySelector('.warna-product-swatch-wrapper').classList.remove('active'); 
              }            
          }
      });
      
      pdpColorLabel.querySelector('.color-product-swatch-wrapper').classList.add('active');
      if(optionsLanguageLabel.length > 0) {
          pdpColorLabel.querySelector('.warna-product-swatch-wrapper').classList.add('active');
      }
      var pdpBadgesContainers = document.querySelectorAll('.pdp-product-badges');
      if(pdpColorLabel.querySelector('.card-badge')){
        var pdpColorLabelBadge = pdpColorLabel.querySelector('.card-badge').innerHTML;
      }
      if(pdpColorLabelBadge && pdpColorLabelBadge != ''){
        var pdpBadgeChanges = document.querySelectorAll('.pdp-badge');
        if(pdpBadgeChanges){

          if(pdpBadgesContainers){
            pdpBadgesContainers.forEach(pdpBadgesContainer => {
              pdpBadgesContainer.innerHTML = `<span class="pdp-badge uppercase">${pdpColorLabelBadge}</span>`;
            })
          }
          
        }
        else{
          if(pdpBadgesContainers){
            pdpBadgesContainers.forEach(pdpBadgesContainer => {
              pdpBadgesContainer.innerHTML = `<span class="pdp-badge uppercase">${pdpColorLabelBadge}</span>`;
            })
          }
          // document.querySelector('.pdp-product-badges').innerHTML = `<span class="pdp-badge uppercase">${pdpColorLabelBadge}</span>`;
        }
        
      }else{ 
        
        if(pdpBadgesContainers){
          pdpBadgesContainers.forEach(pdpBadgesContainer => {
            pdpBadgesContainer.innerHTML = `<span class="pdp-badge uppercase"></span>`;
          })
        }
        document.querySelector('.pdp-product-badges').innerHTML = '';
      }

      var colorCollection = pdpColorLabel.getAttribute('data-collection');

      var pdpColorLabelValue = pdpColorLabel.getAttribute('data-value');
      var pdpColorLabelSwatchClass = pdpColorLabel.getAttribute('data-swatch-class');
      var swatchesParentLabelValue = pdpColorLabel.closest('.swatches-wrapper').previousElementSibling.querySelector('.selected-swatch-color');
      
      var pdpColorLabelPrice = pdpColorLabel.querySelector('.color-product-swatch-wrapper').getAttribute('data-variant-price');
      var pdpColorLabelComparePrice = pdpColorLabel.querySelector('.color-product-swatch-wrapper').getAttribute('data-variant-compare-price');
      var pdpColorLabelDiscount = pdpColorLabel.querySelector('.color-product-swatch-wrapper').getAttribute('data-variant-discount');

          var colorLabels = document.querySelectorAll('.swatches-wrapper .option-color-label');
    var anchors = document.querySelectorAll('.collection-shop-all a');
           anchors.forEach(function(anchor) {
        anchor.style.display = 'none';
    });
                var dataShopAllValue = pdpColorLabel.getAttribute('data-shop-all');
            var previousSibling = pdpColorLabel.parentElement.previousElementSibling;
          var anchor = previousSibling.querySelector('a');
          if (anchor) {
                    anchor.href = dataShopAllValue;
                    anchor.style.display = 'inline-block';
                }

      var pdpPrices = document.querySelectorAll('.pdp-price');

      if(swatchesParentLabelValue){
        swatchesParentLabelValue.innerHTML = pdpColorLabelValue;
      }

      var swatchesParentLabel = pdpColorLabel.closest('.swatches-wrapper').previousElementSibling;
      if(swatchesParentLabel.classList.contains('core-swatches-label')){
        swatchesParentLabel.classList.add('active-swatch-group');
        document.querySelector('.limited-product-colors.swatches-wrapper').previousElementSibling.classList.remove('active-swatch-group');
        document.querySelector('.limited-swatches-label').querySelector('span.selected-swatch-color').innerHTML = '';
        document.querySelector('.limited-swatches-label').querySelector('.collection-shop-all a').setAttribute('href','')
      }else if(swatchesParentLabel.classList.contains('limited-swatches-label')){
        swatchesParentLabel.classList.add('active-swatch-group');
        document.querySelector('.core-color-products.swatches-wrapper').previousElementSibling.classList.remove('active-swatch-group');
        document.querySelector('.core-swatches-label').querySelector('span.selected-swatch-color').innerHTML = '';
        document.querySelector('.core-swatches-label').querySelector('.collection-shop-all a').setAttribute('href','')
      }
      const swatch_new_color = document.querySelector('.sticky-swatch__wrapper .swatch');
      const prefix_color = 'css_swatch_color';
      const classList = swatch_new_color.classList;
      const classesToRemove = Array.from(classList).filter(className => className.startsWith(prefix_color));
      classesToRemove.forEach(className => {
          swatch_new_color.classList.remove(className);
      });
      swatch_new_color.classList.add(pdpColorLabelSwatchClass);
      document.querySelector('.sticky-color-value').textContent = pdpColorLabelValue;
      setTimeout(function() {
      const liElement = document.querySelector('.main_gallery_list li:not(.hidden)');

      // Check if such an li element was found
      if (liElement) {
        // Find the img tag inside the nested structure
        const imgTag = liElement.querySelector('.product-media-container .product__modal-opener .product__media img');
        
        // Check if an img tag was found
        if (imgTag) {
          let imgSrc = imgTag.src;
           imgSrc = imgSrc.split('?')[0];
          const stickyImgTag = document.querySelector('.sticky-product-info img');

          // Check if the sticky img tag was found
          if (stickyImgTag) {
            // Assign the modified src to the sticky img tag
            stickyImgTag.src = imgSrc;
          }
        } else {
          console.log('No img tag found inside the selected li element.');
        }
      }
        }, 1000);
      // change gallery images on basis of color selection pdp
      var color_sku = pdpColorLabel.querySelector('.color-product-swatch-wrapper').getAttribute('color-sku') || pdpColorLabel.querySelector('.warna-product-swatch-wrapper').getAttribute('data-sku');
      var productImages = document.querySelectorAll('.product__media-item'); 
      if (productImages) { 
        productImages.forEach(productImage => {
          var productImageColor = productImage.getAttribute('data-media-url');
          
          if (productImageColor && productImageColor.includes(color_sku)) {
            productImage.classList.remove('hidden');
          } else {
            productImage.classList.add('hidden');
          }
        });
      }

    })
  })
}

// pdp size selection
var pdpATCBtn = document.querySelector('.product-form__submit');
var sizeContainer = document.querySelector('.not-color-options.swatches-wrapper')



// price change variant
var pdpLabels = document.querySelectorAll('.product-options-labels');
if(pdpLabels){
  pdpLabels.forEach(pdpLabel => {
    pdpLabel.addEventListener('click', () => {
      var pdpLabelPrice = pdpLabel.getAttribute('data-variant-price');
      var pdpLabelComparePrice = pdpLabel.getAttribute('data-variant-compare-price');
      var pdpLabelDiscount = pdpLabel.getAttribute('data-variant-discount');
      
      var labelInput = pdpLabel.previousElementSibling; 
      if(labelInput.classList.contains('disabled')){
        document.querySelector('.product-form__submit').classList.add('hidden');
      }else{
        document.querySelector('.product-form__submit').classList.remove('hidden');
      }
      
    })
  })
}

var fitDescriptionLink = document.querySelector('a.mobile-fit-description-link');
if (fitDescriptionLink) {
  fitDescriptionLink.addEventListener('click', (e) => {
    e.preventDefault();
    var thisHash = fitDescriptionLink.hash;
    var targetElement = document.querySelector(thisHash);
    if (targetElement) {
      var targetPosition = targetElement.getBoundingClientRect().top;
      var additionalOffset = 20; // Set the desired additional offset value
      window.scrollTo({
        top: targetPosition - additionalOffset,
        behavior: 'smooth'
      });
    }
  });
}

var stickySwatchLink = document.querySelector('a.sticky-swatch__wrapper-link');
if (stickySwatchLink) {
  stickySwatchLink.addEventListener('click', (e) => {
    e.preventDefault();
    var thisHash = stickySwatchLink.hash;
    var targetElement = document.querySelector(thisHash);
    if (targetElement) {
      var targetPosition = targetElement.getBoundingClientRect().top;
      var additionalOffset = 20; // Set the desired additional offset value
      window.scrollTo({
        top: targetPosition - additionalOffset,
        behavior: 'smooth'
      });
    }
  });
}



// pdp sticky atc bar
var addCartBtn = document.querySelector(".product-form__submit");
var stickyAtcBar = document.querySelector(".sticky-atc-bar");
window.addEventListener("scroll", function () {
  if (addCartBtn) {
    var triggerRect = addCartBtn.getBoundingClientRect();
  }
  if (stickyAtcBar) {
    if (triggerRect && triggerRect.bottom < 0) {
      stickyAtcBar.classList.remove("hidden");
    } else {
      stickyAtcBar.classList.add("hidden");
    }
  }
});

var stickyAtcButton = document.querySelector(".sticky-atc-btn");
if (stickyAtcButton) {
  stickyAtcButton.addEventListener("click", () => {
    document.querySelector(".product-form__submit").click();
  });
}

var pdpSizeLabels = document.querySelectorAll(".pdp-size-label");
var pdpColorLabels = document.querySelectorAll(".pdp-color-label");
if (pdpSizeLabels) {
  pdpSizeLabels.forEach((pdpSizeLabel) => {
    
    pdpSizeLabel.addEventListener("click", () => {
      document.querySelector('.sticky-option-size').classList.remove('hidden');
      var pdpSizeValue = pdpSizeLabel.getAttribute("data-value");
      document.querySelector(".sticky-size-value").textContent = pdpSizeValue;
    });
  });
}
if (pdpColorLabels) {
var sizeCheckSelect = document.querySelector('.select__select-size-check');
  if(sizeCheckSelect){
    var sizeOptionIndex = sizeCheckSelect.dataset.sizePosition;
  }
  if(document.querySelector('.product-form__input.color input:checked')){
    var firstSelectedColor = document.querySelector('.product-form__input.color input:checked').getAttribute('value').toLowerCase();
    document.querySelector('.product-form__input.color input:checked').nextElementSibling.click();
  }
  
  if(sizeCheckSelect){
    
    sizeCheckSelect.querySelectorAll('option').forEach(function(option){
        
      var getVariantTitle = option.dataset.variantTitle;
      if(sizeOptionIndex == 1){
        var getVariantTitleSize = option.dataset.variantTitle.trim().split(' / ')[0];
      }else{
        var getVariantTitleSize = option.dataset.variantTitle.trim().split(' / ')[1];
      }
      
      if(getVariantTitle.includes(firstSelectedColor)){
  
        pdpSizeLabels.forEach(pdpSizeName => {
         
          if(option.dataset.variantInventory <= 0){
            if(pdpSizeName.dataset.label.trim() == getVariantTitleSize.trim()){
            
              setTimeout(function(){
                pdpSizeName.previousElementSibling.classList.add('disabled');
              },100)   
          }
          }else{
              pdpSizeName.previousElementSibling.classList.remove('disabled');
          }
          var getSizeValue = pdpSizeName.dataset.label.toLowerCase();
        });
        
      }
    })
  }
  
  
  pdpColorLabels.forEach((pdpColorLabel) => {
    pdpColorLabel.addEventListener("click", () => {

      pdpSizeLabels.forEach(pdpSizeName => {
        if(pdpSizeName.previousElementSibling.checked){
          pdpSizeName.previousElementSibling.checked = false;
        }
      }) 
      var ColorOptionValue = pdpColorLabel.dataset.value.toLowerCase(); 
      
      sizeCheckSelect.querySelectorAll('option').forEach(function(option){
        var getVariantTitle = option.dataset.variantTitle; 
        
        if(sizeOptionIndex == 1){
        var getVariantTitleSize = option.dataset.variantTitle.trim().split(' / ')[0];
        }else{
          var getVariantTitleSize = option.dataset.variantTitle.trim().split(' / ')[1];
        } 
        if(getVariantTitle.includes(ColorOptionValue)){ 
          pdpSizeLabels.forEach(pdpSizeName => {
            pdpSizeName.previousElementSibling.classList.add('disabled');
            if(getVariantTitle.includes(pdpSizeName.dataset.label.trim())){ 
              var getOptions = sizeCheckSelect.querySelectorAll('option[data-variant-title="' + getVariantTitle + '"]'); 
              if(getOptions.length >= 1){
                getOptions.forEach(getOption => { 
                  if(getOption != undefined){
                      var newVariantTitle = getOption.dataset.variantTitle;
                      const variantArray = newVariantTitle.split(' / '); 
                     
                      let hasExactMatch = false;
                      for (const item of variantArray) {
                        if (item === pdpSizeName.dataset.label.trim()) {
                          hasExactMatch = true;
                          if(parseInt(getOption.dataset.variantInventory) > 0 && hasExactMatch){
                            setTimeout(function(){
                              pdpSizeName.previousElementSibling.classList.remove('disabled');
                            },100)
                          }
                          
                        }
                      } 
                  }
                
              })
              }
              else{
                if(option.dataset.variantInventory <= 0 || getOptions.length == 0){
                    setTimeout(function(){
                      pdpSizeName.previousElementSibling.classList.add('disabled');
                    },100)
                }else{
                    pdpSizeName.previousElementSibling.classList.remove('disabled');
                }
              }
              
            }
            
            if (sizeOptionIndex == 1) {
             var variantCombination = pdpSizeName.dataset.label.trim() + " / " + ColorOptionValue;
            }else{
              var variantCombination = ColorOptionValue + " / " +  pdpSizeName.dataset.label.trim();
            }    
            var matchingOptions = sizeCheckSelect.querySelectorAll('option[data-variant-title="' + variantCombination + '"]');
            var getSizeValue = pdpSizeName.dataset.label.toLowerCase();
          });
        } 
      })
      
      var pdpColorValue = pdpColorLabel.getAttribute("data-value");
      document.querySelector(".sticky-color-value").textContent = pdpColorValue;
    });
  });
}


// close mobile quick add 
var mobileQuickAddClose = document.querySelector('.quickadd-mobile-close');
if(mobileQuickAddClose){
  mobileQuickAddClose.addEventListener('click', () => {
    document.querySelector('.mobile-quick-add-wrapper').classList.add('hidden');
    document.querySelector('.mobile-quick-add').classList.remove('visible');
  })
}

 
var sizeGuideBtns = document.querySelectorAll(".sgtab-btn");
if (sizeGuideBtns) {
  sizeGuideBtns.forEach((sizeGuideBtn) => {
    sizeGuideBtn.addEventListener("click", () => {
      sizeGuideBtns.forEach((siblingSgBtn) => {
        if (siblingSgBtn != sizeGuideBtn) {
          siblingSgBtn.classList.remove("active-sgtab");
        }
      });
      sizeGuideBtn.classList.add("active-sgtab");
      dataSizeGuideTab = sizeGuideBtn.textContent.toLowerCase();
    
      if (dataSizeGuideTab == "men") {
        document.querySelector(".sgtabs-indicator").style.left = "50%";
        document.querySelector(".size-guide-tabs-content.women").classList.add("hidden");
        document.querySelector(".size-guide-tabs-content.men").classList.remove("hidden");
      } else {
        document.querySelector(".sgtabs-indicator").style.left = "0";
        document.querySelector(".size-guide-tabs-content.men").classList.add("hidden");
        document.querySelector(".size-guide-tabs-content.women").classList.remove("hidden");
      }
      // document.querySelector('.size-guide-tabs-content').classList.add('hidden');
      // document.querySelector('.size-guide-tabs-content.'+dataSizeGuideTab).classList.remove('hidden');
    });
  });
}

// size guide countries toggle
var sizeCountries = document.querySelector(".dropdown-other-countries");
if (sizeCountries) {
  var sizeCountryItems = sizeCountries.querySelectorAll("li");
  sizeCountryItems.forEach((sizeCountryItem) => {
    sizeCountryItem.addEventListener("click", () => {
      var dataCountry = sizeCountryItem.getAttribute("data-country");
      var countryRows = document.querySelectorAll(".dynamic-country-row");
      countryRows.forEach((countryRow) => {
        var dataCountryRow = countryRow.getAttribute("data-country");
        if (dataCountryRow == dataCountry) {
          countryRow.classList.remove("hidden");
        } else {
          countryRow.classList.add("hidden");
        }
      });

      document.querySelector(".selected-country").innerHTML = sizeCountryItem.innerHTML;
      sizeCountryItem.closest("details").removeAttribute("open");
    });
  });
}

// size-menu-toggle men
var menSizeMenu = document.querySelector(".size-tabs-menu-men");
if(menSizeMenu){

  // on load men active item 

  var initialActiveItem = menSizeMenu.querySelector(".item.active");
  if(initialActiveItem){
    var dataInitialActiveItem = initialActiveItem.getAttribute("data-type");
    
    if (dataInitialActiveItem == "shoes-socks") {
      document.querySelector(".bra-table-data").style.display = "block";
    } else {
      document.querySelector(".bra-table-data").style.display = "none";
    }
    
    initialActiveItem.closest('.size-guide-tabs-content').querySelectorAll('.table-wrapper').forEach(function(tableWrapper){
      tableWrapper.classList.add('hidden');
    });
    
    initialActiveItem.closest('.size-guide-tabs-content').querySelectorAll('.table-wrapper.'+dataInitialActiveItem).forEach(function(tableWrapper){
      tableWrapper.classList.remove('hidden');
    });
  }
  
  

  
  menMenuItems = menSizeMenu.querySelectorAll(".item");
  menMenuItems.forEach((menMenuItem) => {
    menMenuItem.addEventListener("click", () => {
      menMenuItem.classList.add("active");

      menMenuItems.forEach((menMenuItemSibling) => {
        if (menMenuItemSibling != menMenuItem) {
          menMenuItemSibling.classList.remove("active");
        }
      });

      var dataMenuItem = menMenuItem.getAttribute("data-type");
      
      if (dataMenuItem == "shoes-socks") {
        document.querySelector(".bra-table-data").style.display = "block";
      } else {
        document.querySelector(".bra-table-data").style.display = "none";
      }

      menMenuItem.closest('.size-guide-tabs-content').querySelectorAll('.table-wrapper').forEach(function(tableWrapper){
        tableWrapper.classList.add('hidden');
      });

      menMenuItem.closest('.size-guide-tabs-content').querySelectorAll('.table-wrapper.'+dataMenuItem).forEach(function(tableWrapper){
        tableWrapper.classList.remove('hidden');
      });

    })
  });
}
// toggle-women
var womenSizeMenu = document.querySelector(".size-tabs-menu-women");
if (womenSizeMenu) {

  // on load women active item 
  var activeItem = womenSizeMenu.querySelector(".item.active");
  
  if(activeItem){
    var activeItemValue = activeItem.getAttribute('data-type');
   
    if (activeItem == "bra-table" || activeItem == "bodysuits-dresses") {
        document.querySelector(".bra-table-data").style.display = "block";
      } else {
        document.querySelector(".bra-table-data").style.display = "none";
      }

      if (activeItem == "bottoms") {
        document.querySelector(".bottoms-data").classList.remove('hidden');
      } else {
        document.querySelector(".bottoms-data").classList.add('hidden');
      }

      if (activeItem == "bodysuits-dresses") {
        var toggleValue = document.querySelector('.table-wrapper.bra-table.jackets-sweatshirts.bodysuits-dresses').querySelector('input[data-position]').getAttribute('data-position');
      
        if(toggleValue == 'left'){
          document.querySelector('.conversion-row.bodysuits-dresses[data-unit-type="cm"]').classList.remove('hidden');
          // document.querySelector('.conversion-row.bodysuits-dresses[data-unit-type="in"]').classList.add('hidden');
        } else {
          document.querySelector('.conversion-row.bodysuits-dresses[data-unit-type="cm"]').classList.add('hidden');
        }
      }  
      
      activeItem.closest('.size-guide-tabs-content').querySelectorAll('.table-wrapper').forEach(function(tableWrapper){
        tableWrapper.classList.add('hidden');
      });

      activeItem.closest('.size-guide-tabs-content').querySelectorAll('.table-wrapper.'+activeItemValue).forEach(function(tableWrapper){
        tableWrapper.classList.remove('hidden');
      });
  }
  
  womenMenuItems = womenSizeMenu.querySelectorAll(".item");
  womenMenuItems.forEach((womenMenuItem) => {
    womenMenuItem.addEventListener("click", () => {
      womenMenuItem.classList.add("active");
      womenMenuItems.forEach((womenMenuItemSibling) => {
        if (womenMenuItemSibling != womenMenuItem) {
          womenMenuItemSibling.classList.remove("active");
        }
      });

      var dataMenuItem = womenMenuItem.getAttribute("data-type");
    
      if (dataMenuItem == "bra-table" || dataMenuItem == "bodysuits-dresses") {
        document.querySelector(".bra-table-data").style.display = "block";
      } else {
        document.querySelector(".bra-table-data").style.display = "none";
      }

      if (dataMenuItem == "bottoms") {
        document.querySelector(".bottoms-data").classList.remove('hidden');
      } else {
        document.querySelector(".bottoms-data").classList.add('hidden');
      }

      if (dataMenuItem == "bodysuits-dresses") {
        var toggleValue = document.querySelector('.table-wrapper.bra-table.jackets-sweatshirts.bodysuits-dresses').querySelector('input[data-position]').getAttribute('data-position');
        
        if(toggleValue == 'left'){
          document.querySelector('.conversion-row.bodysuits-dresses[data-unit-type="cm"]').classList.remove('hidden');
          // document.querySelector('.conversion-row.bodysuits-dresses[data-unit-type="in"]').classList.add('hidden');
        } else {
          document.querySelector('.conversion-row.bodysuits-dresses[data-unit-type="cm"]').classList.add('hidden');
        }
      }  
      
      womenMenuItem.closest('.size-guide-tabs-content').querySelectorAll('.table-wrapper').forEach(function(tableWrapper){
        tableWrapper.classList.add('hidden');
      });

      womenMenuItem.closest('.size-guide-tabs-content').querySelectorAll('.table-wrapper.'+dataMenuItem).forEach(function(tableWrapper){
        tableWrapper.classList.remove('hidden');
      });

    });
  });
}

var heightButtonsWrapper = document.querySelector('.height-buttons-wrapper');
if(heightButtonsWrapper){
  var heightButtons = heightButtonsWrapper.querySelectorAll('.height-button');
  if(heightButtons){
    heightButtons.forEach(heightButton => {
      heightButton.addEventListener('click', () => {
        heightButton.classList.add("active");
        heightButtons.forEach((heightButtonItemSibling) => {
          if (heightButtonItemSibling != heightButton) {
            heightButtonItemSibling.classList.remove("active");
          }
        });
  
        if(heightButton.getAttribute('data-testid') == 'size-guide-users-height-fiveSevenToFiveNine'){
          document.querySelector('.lf-1-desc').querySelector('span').textContent = 'Hits above ankle';
          document.querySelector('.lf-2-desc').querySelector('span').textContent = 'Hits low calf';
          document.querySelector('.lf-3-desc').querySelector('span').textContent = 'Hits mid calf';
        }else{
          document.querySelector('.lf-1-desc').querySelector('span').textContent = 'Hits below ankle';
          document.querySelector('.lf-2-desc').querySelector('span').textContent = 'Hits above ankle';
          document.querySelector('.lf-3-desc').querySelector('span').textContent = 'Hits low calf';
        }
  
      })
    })
  }
}



var sizeUnitToggles = document.querySelectorAll('.toggle-container input[type="checkbox"]');
if (sizeUnitToggles) {
  sizeUnitToggles.forEach((sizeUnitToggle) => {
    sizeUnitToggle.addEventListener("change", (event) => {
      var inputPosition = sizeUnitToggle.getAttribute("data-position");
      var thisParentTable = event.target.closest(".size-table"); 
      var convesionRows = thisParentTable.querySelectorAll(".conversion-row");

      if (inputPosition == "left") {
        sizeUnitToggle.setAttribute("data-position", "right"); 

        if (convesionRows) {
          convesionRows.forEach((convesionRow) => {
            var conversionRowValueType = convesionRow.getAttribute("data-unit-type"); 
            if (conversionRowValueType == "cm") {
              convesionRow.classList.add("hidden");
            } else {
              convesionRow.classList.remove("hidden");
            } 
          });
        }
      } else {
        sizeUnitToggle.setAttribute("data-position", "left"); 

        if (convesionRows) {
          convesionRows.forEach((convesionRow) => {
            var conversionRowValueType =
              convesionRow.getAttribute("data-unit-type"); 
            if (conversionRowValueType == "in") {
              convesionRow.classList.add("hidden");
            } else {
              convesionRow.classList.remove("hidden");
            }
          });
        }
      }
    });
  });
}



// cart

var headerCartIcon = document.querySelector(".header__icon--cart");
var hoverCartContainer = document.querySelector(".hover-cart-drawer");
var cartRectWrapper = document.querySelector(".rect__wrapper");

if(document.querySelector('body').classList.contains('template-cart') == false){
if (headerCartIcon) {
  headerCartIcon.addEventListener("mouseover", () => {
    hoverCartContainer.style.display = "block";
    cartRectWrapper.style.opacity = "1";
    cartRectWrapper.style.visibility = "visible";
  });
  hoverCartContainer.addEventListener("mouseleave", () => {
    hoverCartContainer.style.display = "none";
    cartRectWrapper.style.opacity = "0";
    cartRectWrapper.style.visibility = "hidden";
  });
}  
}


var cartNote = document.querySelector(".text-area");
if (cartNote) {
  cartNote.addEventListener("click", () => {
    cartNote.classList.add("focused");
  });
}
 

const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('animated');
      return;
    }

    entry.target.classList.remove('animated');
  });
});
 
const squares = document.querySelectorAll('.collection-list-wrapper .animatable');
 
squares.forEach((element) => observer.observe(element));


// scroll to top
var toTop = document.getElementById('toTop');
if(toTop){
  toTop.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  })

  var docheight = document.innerHeight;

  function getDocHeight() {
    var D = document;
    return Math.max(
    D.body.scrollHeight, D.documentElement.scrollHeight,
    D.body.offsetHeight, D.documentElement.offsetHeight,
    D.body.clientHeight, D.documentElement.clientHeight
    )
    }
    var docheight = getDocHeight()

  function amountscrolled(){
    var winheight= window.innerHeight || (document.documentElement || document.body).clientHeight
    var docheight = getDocHeight()
    var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
    var trackLength = docheight - winheight
    var pctScrolled = Math.floor(scrollTop/trackLength * 100) // gets percentage scrolled (ie: 80 or NaN if tracklength == 0)

      if(pctScrolled > 50){
        toTop.classList.remove('hide')
      }else{
        toTop.classList.add('hide')
      }
    }
    
    window.addEventListener("scroll", function(){
      amountscrolled()
    }, false)
 
}

// free gift 
var redeemBtns = document.querySelectorAll('.redeem-btn');
if(redeemBtns){
  redeemBtns.forEach(redeemBtn => {
    redeemBtn.addEventListener('click',() => {
      redeemBtn.closest('form').submit();
    })
  })
}


// reorder feature
var reOrderBtns = document.querySelectorAll('.reorder-btn');
if(reOrderBtns){
  reOrderBtns.forEach(reOrderBtn => {
    reOrderBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      var orderForm = reOrderBtn.closest('form');
      if(reOrderBtn.classList.contains('cart-empty')){
        orderForm.submit();
        setTimeout(function(){
          window.location.href = '/checkout'
        },100)
      }else{

        reOrderBtn.closest('form').querySelector('#myModal').style.display = 'flex'

      }
    });
    
    var replaceCartBtn = reOrderBtn.closest('form').querySelector('.replace-cart-btn');
    if(replaceCartBtn){
      replaceCartBtn.addEventListener('click', (e) => {
        e.preventDefault();

        // Function to clear the cart
        const clearCart = async () => {
          try {
              const response = await fetch('/cart/clear.js', {
                  method: 'POST'
              });
              
              if (!response.ok) {
                  throw new Error('Failed to clear cart');
              }
              
              reOrderBtn.closest('form').submit();
              setTimeout(function(){
                window.location.href = '/checkout'
              },100)
          } catch (error) {
              console.error('Error clearing cart:', error);
          }
        };

        clearCart();

      })
      
    }


    var mergeCartBtn = reOrderBtn.closest('form').querySelector('.merge-cart-btn');
    if(mergeCartBtn){
      mergeCartBtn.addEventListener('click', () => {
        reOrderBtn.closest('form').submit();
        setTimeout(function(){
          window.location.href = '/checkout'
        },100)
      })
    }
  
  });
  
}


// cart gift message 
function giftMessage() {
  var cartNoteBox = document.querySelector('.cart__note .text-area');
  var cartNoteBoxLength = cartNoteBox.value.length;
  var giftSuccess = document.querySelector('.gift-change-success');

  // if (cartNoteBoxLength >= 3 && giftSuccess.classList.contains('hidden')) {}
    giftSuccess.style.opacity = 1;
    setTimeout(function() {
      giftSuccess.style.opacity = 0;
    }, 600);
  

}


  
var live_url = window.location.href;
var result = live_url.includes('form_type=customer');
var newsletter_input = document.querySelector('.newsletter-footer-input');
var input_val = document.querySelector('.newsletter-footer-input').value.length;
if(result && input_val != 0){
    const add_ele = document.createElement("h3");
    add_ele.innerText = newsletter_input.getAttribute('data-success');
    document.querySelector('.newsletter-form__field-wrapper').appendChild(add_ele);
    add_ele.classList.add('newsletter_already_subscribe','newsletter-form__message','form__message','newsletter-form__message--success');
}

// newsletter_input.addEventListener('input', () => {
//   if(input_val == 0){
//     document.querySelector('.newsletter_already_subscribe').classList.add('hidden')
//   }
  
// })

// footer accordions
var footerHeadings = document.querySelectorAll(".menu-footer-heading");
if (footerHeadings) {
  footerHeadings.forEach((footerHeading) => {
    footerHeading.addEventListener("click", () => {
      if (footerHeading.nextElementSibling.classList.contains("active")) {
        footerHeading.nextElementSibling.classList.remove("active");
        footerHeading.querySelector("span").style.transform = "rotate(0deg)";
      } else {
        footerHeading.nextElementSibling.classList.add("active");
        footerHeading.querySelector("span").style.transform = "rotate(180deg)";
      }
    });
  });
}

var footerNewsletterForm = document.querySelector('form#ContactFooter');
if(footerNewsletterForm){
  footerNewsletterForm.addEventListener('submit',function(event){

    var newsletterInput = footerNewsletterForm.querySelector('.newsletter-footer-input');
    var newsletterInputLength = footerNewsletterForm.querySelector('.newsletter-footer-input').value.length;
    if(newsletterInputLength == 0 || newsletterInput.value.includes('@') == false){
      event.preventDefault();
    }else{
      document.querySelector('.form-message-submitting').classList.remove('hidden');
      document.querySelector('.form-message-submitting').innerHTML = 'Submitting...';
      if(document.querySelector('small#ContactFooter-error')){
        document.querySelector('small#ContactFooter-error').classList.add('hidden');
      }
      if(document.querySelector('.newsletter_already_subscribe')){
        document.querySelector('.newsletter_already_subscribe').classList.add('hidden');
      }
      if(document.querySelector('.newsletter-form__message--success')){
        document.querySelector('.newsletter-form__message--success').classList.add('hidden');
      } 
    }
    
  });
}


var footerNewsletterBtn = document.querySelector('.footer-newsletter-btn');
if(footerNewsletterBtn){
  footerNewsletterBtn.addEventListener('click', () => {
    var newsletterInput = footerNewsletterForm.querySelector('.newsletter-footer-input');
    var newsletterInputLength = footerNewsletterForm.querySelector('.newsletter-footer-input').value.length;
   
    if(newsletterInputLength == 0 || newsletterInput.value.includes('@') == false || newsletterInput.value.includes('.com') == false){
      newsletterInput.classList.add('input-error');
     
      footerNewsletterForm.querySelector('.error-empty-email').classList.remove('hidden');
      document.querySelector('.newsletter_already_subscribe').classList.add('hidden');
    }else{

      document.querySelector('.form-message-submitting').classList.remove('hidden');
      document.querySelector('.form-message-submitting').innerHTML = 'Submitting...';
      if(document.querySelector('small#ContactFooter-error')){
        document.querySelector('small#ContactFooter-error').classList.add('hidden');
      }
      if(document.querySelector('.newsletter_already_subscribe')){
        document.querySelector('.newsletter_already_subscribe').classList.add('hidden');
      }
      if(document.querySelector('.newsletter-form__message--success')){
        document.querySelector('.newsletter-form__message--success').classList.add('hidden');
      } 
      
      footerNewsletterForm.submit();
    }
  })
}


// career page
var listingFilterBtns = document.querySelectorAll('.listing_filter_btn');
if(listingFilterBtns){
  listingFilterBtns.forEach(listingFilterBtn => {
    listingFilterBtn.addEventListener('click', (e) => {
      var thisFilterDropdown = listingFilterBtn.nextElementSibling;
      thisFilterDropdown.classList.add('active');
      var otherListingDropdowns = listingFilterBtn.closest('.career__dropdowns').querySelectorAll('.filter_selection_drop');
      
      if(otherListingDropdowns){
        otherListingDropdowns.forEach(otherListingDropdown => {
          if(otherListingDropdown.classList.contains('active') && thisFilterDropdown != otherListingDropdown){
            otherListingDropdown.classList.remove('active');
          }
        })
      }

      
    })
    
  })

  
  document.querySelector('body').addEventListener('click', (ev) => {

    setTimeout(function(){
      //  && ![...document.querySelectorAll('.filter_select_ul li')].includes(ev.target)
      if (ev.target !== document.querySelector('.listing_filter_btn_1') && !ev.target.closest('.listing_filter_btn_1') && ev.target !== document.querySelector('.listing_filter_btn_2') && !ev.target.closest('.listing_filter_btn_2')) {
        var activeDropdowns = document.querySelectorAll('.filter_selection_drop.active');
        activeDropdowns.forEach(activeDropdown => {
          activeDropdown.classList.remove('active');
        });
      }
    },10)
    
  });
}

var departmentListItems = document.querySelectorAll('.filter_select_ul_departments li');
if (departmentListItems) {
  departmentListItems.forEach(departmentListItem => {
    departmentListItem.addEventListener('click', () => {
      departmentListItem.closest('.listing_dropdown').querySelector('.filter_title').innerHTML = departmentListItem.innerHTML;

      var jobListings = document.querySelectorAll('.listing_job_department');

      jobListings.forEach(jobListing => {
        if(departmentListItem.textContent == 'All Departments'){
          var listingDetailsMains = document.querySelectorAll('.listing_details_main');
          listingDetailsMains.forEach(listingDetailsMain => {
            listingDetailsMain.style.display = 'block';
          });
          
        }else if (jobListing.textContent.trim() === departmentListItem.textContent.trim()) {
          
          // Add your code here to handle the match
          // Hide all the .listing_details_main elements
          var listingDetailsMains = document.querySelectorAll('.listing_details_main');
          listingDetailsMains.forEach(listingDetailsMain => {
            listingDetailsMain.style.display = 'none';
          });
          // Show the matched .listing_details_main element
          var parentListingDetailsMain = jobListing.closest('.listing_details_main');
          
          if (parentListingDetailsMain) {
            parentListingDetailsMain.style.display = 'block';
          }
          var parentListingDetailsMainListings = parentListingDetailsMain.querySelectorAll('.listing_job_items').length;
         
          if(parentListingDetailsMainListings == 1){
            document.querySelector('.career_filters_count').textContent = parentListingDetailsMainListings + ' Listing';
          }else{
            document.querySelector('.career_filters_count').textContent = parentListingDetailsMainListings + ' Listings';
          }
          
        }
        
      });
    });
  });
}

var locationListItems = document.querySelectorAll('.filter_select_ul_locations li');
if (locationListItems) {
  locationListItems.forEach(locationListItem => {
    locationListItem.addEventListener('click', () => {
      
      locationListItem.closest('.listing_dropdown').querySelector('.filter_title').innerHTML = locationListItem.innerHTML;

      var jobListings = document.querySelectorAll('.listing_job_location');
    

      jobListings.forEach(jobListing => {
        if(locationListItem.textContent.toLowerCase() == 'all locations'){
         
          var listingDetailsMains = document.querySelectorAll('.listing_details_main');
          listingDetailsMains.forEach(listingDetailsMain => {
            listingDetailsMain.style.display = 'block';
          });
          
        }else if (jobListing.textContent.toLowerCase() === locationListItem.textContent.toLowerCase()) {
        
          // Add your code here to handle the match
          // Hide all the .listing_details_main elements
          var listingDetailsMains = document.querySelectorAll('.listing_details_main');
          listingDetailsMains.forEach(listingDetailsMain => {
            listingDetailsMain.style.display = 'none';
          });
          // Show the matched .listing_details_main element
          var parentListingDetailsMain = jobListing.closest('.listing_details_main');
          if (parentListingDetailsMain) {
            parentListingDetailsMain.style.display = 'block';
          }
          var parentListingDetailsMainListings = parentListingDetailsMain.querySelectorAll('.listing_job_items').length;
          if(parentListingDetailsMainListings == 1){
            document.querySelector('.career_filters_count').textContent = parentListingDetailsMainListings + ' Listing';
          }else{
            document.querySelector('.career_filters_count').textContent = parentListingDetailsMainListings + ' Listings';
          }
        }
        
      });
    });
  });
}



// account pages

const forms = document.querySelectorAll('.account_form');

forms.forEach(form => {
  const inputs = form.querySelectorAll('.main_input_field input');

  inputs.forEach(input => {
    input.addEventListener('input', () => {
      validateInput(input);
    });

    input.addEventListener('blur', () => {
      validateInput(input);
    });

    input.addEventListener('focus', () => {
      removeError(input);
    });
  });

  form.addEventListener('submit', event => {
    event.preventDefault(); 
    validateForm(form);

 
    if (form.checkValidity()) {
      // Your code to submit the form
      // form.submit();
     
    }
  });
});

function validateInput(input) {
  const addvalid = input.closest('.field');
  const errorMessage = addvalid.querySelector('.account_error_input');

  if (!input.checkValidity()) {
    errorMessage.style.display = 'block';
    addvalid.classList.add('input__error');
  } else {
    errorMessage.style.display = 'none';
    addvalid.classList.remove('input__error');
    if (input.value.trim() === "") {
      removeError(input);
    }
  }

  validateForm(input.form);
}

function removeError(input) {
  const addvalid = input.closest('.field');
  const errorMessage = addvalid.querySelector('.account_error_input');

  errorMessage.style.display = 'none';
  addvalid.classList.remove('input__error');
}

function validateForm(form) {
  const inputs = form.querySelectorAll('.main_input_field input');
  const submitbtn = form.querySelector('.account_btn');

  let allInputsValid = true;
  inputs.forEach(input => {
    if (!input.checkValidity() || input.value.trim() === "") {
      allInputsValid = false;
    }
  });

  if (allInputsValid) {
    submitbtn.removeAttribute('disabled');
  } else {
    submitbtn.setAttribute('disabled', true);
  }
}

// pdp warmth popup
var warmthInfo = document.querySelector('svg.info-icon');
if(warmthInfo){
  warmthInfo.addEventListener('click', () => {
    document.querySelector('.warmth_popup').classList.add('show');
  })
}

var warmthPopupClose1 = document.querySelector('.warmth_popup');
if(warmthPopupClose1){
 var warmthPopupClose = warmthPopupClose1.querySelector('.modal_close_icon');
  if(warmthPopupClose){
    warmthPopupClose.addEventListener('click', () => {
      document.querySelector('.warmth_popup').classList.remove('show');
    })
  } 
}



// new to alo for her for him
var forTabs = document.querySelectorAll('.for-tab');
if(forTabs){
  forTabs.forEach(forTab => {
    forTab.addEventListener('click',() => {
      forTab.querySelector('span').classList.add('active');
      forTabs.forEach(forOtherTab => {
        if(forOtherTab != forTab){
          forOtherTab.querySelector('span').classList.remove('active') 
        }
      });
      var dataFor = forTab.getAttribute('data-for');
      var forContentContainers = document.querySelectorAll('.for-content-main-wrapper');
      if(forContentContainers){
        forContentContainers.forEach(forContentContainer => {
          forContentContainer.classList.add('hidden')
        })
      }
      // document.querySelector('.for-content-main-wrapper').classList.add('hidden');
      document.querySelector('.for-content-main-wrapper.'+dataFor).classList.remove('hidden');

      var forHims = document.querySelectorAll('.for-him');
      var forHers = document.querySelectorAll('.for-her');

      if(dataFor == 'for-her'){
        forHers.forEach(forHer => {
          forHer.classList.remove('hidden');
        })
        forHims.forEach(forHim => {
          forHim.classList.add('hidden');
        })
      }else{
        forHers.forEach(forHer => {
          forHer.classList.add('hidden');
        })
        forHims.forEach(forHim => {
          forHim.classList.remove('hidden');
        })
      }

    })
  })
}

var forTabsCollection = document.querySelectorAll('.collection-tab');
if(forTabsCollection){
  forTabsCollection.forEach(forTab => {
    forTab.addEventListener('click',() => {
      forTab.querySelector('span').classList.add('active');
      forTabsCollection.forEach(forOtherTab => {
        if(forOtherTab != forTab){
          forOtherTab.querySelector('span').classList.remove('active') 
        }
      });
      var dataFor = forTab.getAttribute('data-for');
      var forContentContainer = forTab.closest('.collection-list-wrapper');
      var tabCollections = forContentContainer.querySelectorAll('.collection-list__item');
      if(tabCollections){
        tabCollections.forEach(tabCollection => {
          if(tabCollection.getAttribute('data-for') == dataFor){
            tabCollection.classList.remove('hidden');
          }else{
            tabCollection.classList.add('hidden');
          }
          
        })
      }
      // document.querySelector('.for-content-main-wrapper').classList.add('hidden');
      document.querySelector('.for-content-main-wrapper.'+dataFor).classList.remove('hidden');
    })
  })
}

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(event) {
    const  colorSwatchBtn = event.target.matches('.color-product-swatch-wrapper') ? event.target : event.target.closest('.color-product-swatch-wrapper')
    if (colorSwatchBtn) {
      let parent = colorSwatchBtn.closest('.card-product-swatch-button');
      if(!parent) return
      const dataSelect = parent.getAttribute('data-select');
      const select_buttons = dataSelect.replace('select', 'quick_list');
      const buttons_list = document.querySelectorAll('.'+select_buttons+' button[data-size]');
      // buttons_list.forEach(button => {
      //     button.classList.add('no_variant_exist');
      // });
      const dataColorValue = parent.getAttribute('data-color-value');
      
      if (!dataSelect || !dataColorValue) {
        return;
      }
      const selectElement = document.querySelector(`select.${dataSelect}`);
        if (selectElement) {
            let found = false;
            const options = selectElement.querySelectorAll('option');
            options.forEach(option => {
                const variantTitle = option.getAttribute('data-variant-title');
                if (variantTitle && variantTitle.includes(dataColorValue)) {
                    // Create variables for each attribute of the option
                    let optionValue = option.value;
                    let optionVariantId = option.getAttribute('data-variant-id');
                    let optionQuick = option.getAttribute('data-quick');
                    let optionVariantTitle = option.getAttribute('data-variant-title');
                    let optionVariantStock = option.getAttribute('data-variant-stock');
                    // Process the option value to remove dataColorValue, spaces, and '/'
                    // let processedValue = optionValue.replace(new RegExp(`\\s*/\\s*${dataColorValue}`, 'i'), '').trim();
                    selectElement.value = option.value;
                    found = true;
                    const quickElement = document.querySelector(`.${optionQuick}`);
                    if (quickElement) {
                       const buttons = quickElement.querySelectorAll('button[data-size]');

                        buttons.forEach(button => {

                          button.setAttribute('disabled','disabled');
                          var newOptionVariantTitle = option.getAttribute('data-variant-title');
                          const cardVariantArray = newOptionVariantTitle.split(' / '); 
                          
                          let hasExactMatchCard = false;
                          for (const cardItem of cardVariantArray) {
                            if (cardItem === button.dataset.size.trim()) {
                              hasExactMatchCard = true; 
                              if(optionVariantStock === 'available' && hasExactMatchCard){ 
                                    setTimeout(function(){  
                                             button.removeAttribute('disabled'); 
                                            },200) 
                                          } 
                                  }
                                }                      
                            
                        });
                    } else {
                        console.warn('Element with class from optionQuick not found');
                    }
                }
            });
            if (!found) {
                console.warn('No matching option found');
            }
        } else {
            console.error('Select element not found');
        }
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const url = window.location.href;
  
  if (url.includes('filter.v.option.color')) {
   
    setTimeout(function() {
      const parsedUrl = new URL(url);
  const queryParams = new URLSearchParams(parsedUrl.search);
  const colorValues = queryParams.getAll('filter.v.option.color');

  if (colorValues.length === 0) return;

  const productCards = document.querySelectorAll('#product-grid .grid__item');

  productCards.forEach(card => {
    const elements = card.querySelectorAll('.card-product-swatch-button');
    let colorFound = false;

    colorValues.forEach(colorValue => {
      if (!colorFound) {
        elements.forEach(element => {
          if (element.getAttribute('data-color-value') === colorValue && !colorFound) {
            const span = element.querySelector('span.card-product-color-swatch');
            if (span) {
              span.click();
              colorFound = true;
            }
          }
        });
      }
    });
  });
      }, 1000);
  }
  else if (url.includes('search?q')) {
    console.log('search page');
  }
  else{

          setTimeout(function() {
  const elements = document.querySelectorAll('.tr_active_swatch .color-product-swatch');
        elements.forEach(element => {
          element.click();
        });
      }, 1000);
  }
});

    window.addEventListener('DOMContentLoaded', (event) => {
        const sizeOrder = {
            'XXS': 1,
            'XS': 2,
            'S': 3,
            'M': 4,
            'L': 5,
            'XL': 6,
            '2XL': 7
        };

        const containers = document.querySelectorAll('.quickadd-size-btns');
        containers.forEach(container => {
            const buttons = Array.from(container.querySelectorAll('button'));
            const sortedButtons = buttons.sort((a, b) => {
                const sizeA = a.querySelector('.variant_option_value').textContent.trim();
                const sizeB = b.querySelector('.variant_option_value').textContent.trim();
                return sizeOrder[sizeA] - sizeOrder[sizeB];
            });

            sortedButtons.forEach(button => {
                container.appendChild(button);
            });
        });
    });




// ----------------------------New Card Product--------------------------
document.addEventListener("click", function (event) {
  if (event.target.closest(".product-card-wrapper")) {
    const cardProduct = event.target.closest(".product-card-wrapper");
    const colorOption = event.target.matches(".color-swatch-card-product")
      ? event.target
      : event.target.closest(".color-swatch-card-product");
    const sizeOption = event.target.matches(".card_size_option")
      ? event.target
      : event.target.closest(".card_size_option");
   const secondaryImages = cardProduct?.querySelectorAll(".color-sku-img");
   const primaryImage = cardProduct?.querySelector(".card-primary-image");
   const itemTitle = cardProduct?.querySelector(".card-product-link").textContent || "";
 // -------------------------------------Color Options--------------------------------------
    
    if (colorOption) {
          event.preventDefault();
          const optionSku = colorOption.getAttribute("data-sku");
          const cardProductLink = cardProduct?.querySelector('.card-product-link')
           cardProductLink.setAttribute('href' , colorOption.getAttribute('href'))
          const cardSelectedColor =  cardProduct?.querySelector('.card-selected-color')
         if(cardSelectedColor) cardSelectedColor.textContent = colorOption.getAttribute('value')
          const cardDiscountBadge = cardProduct?.querySelector('.card-sale-percentage')
          if(cardDiscountBadge && colorOption.getAttribute('data-discount')) {
            if(parseInt(colorOption.getAttribute('data-discount')) > 0){
             cardDiscountBadge.innerHTML = `<span class="card-discount-badge font-arquitecta fw-500 uppercase">Save <span>${colorOption.getAttribute('data-discount') || ''}</span>%</span>`
            } else{
              cardDiscountBadge.innerHTML = ""
            }
            }
          const cardPrice = cardProduct?.querySelector('.card_price_wrapper')
           if(cardPrice){
             cardPrice.innerHTML = colorOption.querySelector('.color_price_wrapper').innerHTML
           }
          let firstMatchFound = false
          secondaryImages?.forEach(image =>{
            const imageUrl = image.getAttribute('data-media-url')
            if(imageUrl.includes(optionSku) && !firstMatchFound){
            image.classList.add("matched-images")
            image.classList.remove("hidden")
            firstMatchFound = true
            }else{
            image.classList.remove("matched-images")
            image.classList.add("hidden")
            }
          });
          const allColorOptions = cardProduct.querySelectorAll(".color-swatch-card-product");
          allColorOptions?.forEach(color => color.classList.remove("active"));
          colorOption.classList.add("active");
        
          const allSizeOptions = cardProduct.querySelectorAll('.card_size_option');
          const scriptTag = cardProduct.querySelector('script[type="application/json"]');
        
          if (scriptTag) {
            const variants = JSON.parse(scriptTag.textContent) || [];
            const matchingVariants = variants.filter(variant => variant.options.includes(colorOption.getAttribute('value')));
            allSizeOptions.forEach(sizeOption => {
              const sizeValue = sizeOption.getAttribute("value");
              const isAvailable = matchingVariants.some(variant => variant.options.includes(sizeValue) && variant.available);
              if (isAvailable) {
                sizeOption.classList.add("available");
                sizeOption.classList.remove("unavailable");
              } else {
                sizeOption.classList.add("unavailable");
                sizeOption.classList.remove("available");
              }
            });
          }
        }


    // --------------------------------------------Size Options --------------------------------
    
    if (sizeOption) {
      const selectedSize = sizeOption?.getAttribute("value") || "";
      const selectedColor =
        cardProduct
          .querySelector(".color-swatch-card-product.active")
          ?.getAttribute("value") || "";
        const selectedColorGroup = cardProduct
          .querySelector(".color-swatch-card-product.active")
          ?.getAttribute("data-color-group") || "";
        const selectedFilterColor = cardProduct
          .querySelector(".color-swatch-card-product.active")
          ?.getAttribute("data-filter-color") || "";
          const productType =  cardProduct.querySelector(".color-swatch-card-product.active")
          ?.getAttribute("data-product-type") || "";
          const optionSku =  cardProduct.querySelector(".color-swatch-card-product.active") ? cardProduct.querySelector(".color-swatch-card-product.active").getAttribute("data-sku") : '';
      
         let findFirstMatchingImage = Array.from(secondaryImages).find(image => {
            const imageUrl = image.getAttribute('data-media-url');
            return imageUrl.includes(optionSku);
          });

       if(!findFirstMatchingImage){
         findFirstMatchingImage = secondaryImages[0]
       }
       if(!findFirstMatchingImage){
         findFirstMatchingImage = primaryImage
       }
      const scriptTag = cardProduct.querySelector(
        'script[type="application/json"]'
      );

      if (scriptTag) {
        const variants = JSON.parse(scriptTag.textContent) || [];

        const currentVariant = variants.find(
          (variant) =>
            variant.options.includes(selectedSize) &&
            (!selectedColor || variant.options.includes(selectedColor))
        );
         var productRecommendationId = cardProduct.getAttribute('data-product-id');
      var relatedIdHolder = document.querySelector('[data-related-id]');
      if(relatedIdHolder){
        relatedIdHolder.setAttribute('data-related-id',productRecommendationId);
      }
      var miniCartRecommendationsUrl = document.querySelector('.mini-cart-recommendations');
      miniCartRecommendationsUrl?.setAttribute('data-color', selectedColor)
      miniCartRecommendationsUrl?.setAttribute('data-color-group', selectedColorGroup)
      miniCartRecommendationsUrl?.setAttribute('data-filter-color', selectedFilterColor)
      miniCartRecommendationsUrl?.setAttribute('data-product-type', productType)
      miniCartRecommendationsUrl?.refresh()
        window.cartNotification(findFirstMatchingImage.src , itemTitle , selectedColor , selectedSize )
        window.updateCartDrawer(currentVariant)
      } else {
        console.error("Script tag not found");
      }
    }
  }
});

window.updateCartDrawer = function(currentVariant) {
  if (currentVariant) {
    function getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

    const config = {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "application/javascript",
      }
    };
    
    const sectionsToRender = [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cartIconBubble',
        section: 'cart-icon-bubble',
        selector: '.cart-bubble-count',
      }
    ];
    
    let formData = new FormData();
    formData.append("id", currentVariant.id);
    formData.append("quantity", 1);
    formData.append("sections", sectionsToRender.map((section) => section.section));
    formData.append("sections_url", window.location.pathname);
    config.body = formData;
    
    fetch(`/cart/add`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.message);
          return;
        }
        
        const product = response.hasOwnProperty("items")
          ? response.items[0]
          : response;
          
        sectionsToRender.forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          if(sectionElement){
          sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.section], section.selector);
          }
        });
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  } else {
    console.log("No matching variant found.");
  }
}



window.cartNotification = function(colorImg , itemTitle , colorValue , sizeValue  ){
  var dataCartBtn = document.querySelector(".cart-notification__header").getAttribute("data-cart-link");
  var dataShoppingBtn = document.querySelector(".cart-notification__header").getAttribute("data-shopping-link");
  var product_data = `<div class="cart-notification-product__image small-hide global-media-settings">
            <img src="${colorImg}" alt="" width="100" height="auto" loading="lazy">
          </div>
          <div>
            <h3 class="cart-notification-product__name h4">${itemTitle}</h3>
            <dl>
              <div class="product-option">
                <dt>Color:</dt>
                <dd>${colorValue}</dd>
              </div>
              <div class="product-option">
                <dt>Size:</dt>
                <dd>${sizeValue}</dd>
              </div>
            </dl>
            <div class="cart-noitfication-links">
              <a onclick="document.querySelector('.cart-notification__close').click()" href="javacript:void(0)" type="button" class="button-label keep-shopping-btn button button--secondary uppercase font-arquitecta">${dataShoppingBtn}</a>
              <a href="/cart" onclick="window.location.href='/cart'" id="cart-notification-button" class="button button--primary uppercase font-arquitecta">
                ${dataCartBtn}
              </a>
            </div>
          </div>`;

          document.querySelector(".cart-notification-product").innerHTML = product_data; 
          document.querySelector(".cart-notification")?.classList.add('active')
}
  document.addEventListener('click' , function(event){
    if(event.target.matches('.mobile_quick_add_card') || event.target.closest('.mobile_quick_add_card')){
      const cardProduct = event.target.closest(".product-card-wrapper");
      const cardSizes = cardProduct.querySelector('.size_swatches_wrapper') || "";
       document.querySelector('.mobile-quick-add-wrapper').classList.remove('hidden');
          document.querySelector('.mobile-quick-add').classList.add('visible');
      var mobileQuickAddSizesContainer = document.querySelector('.mobile-quick-add').querySelector('.mobile-quickadd-sizes');
      if(cardSizes && mobileQuickAddSizesContainer){
      mobileQuickAddSizesContainer.innerHTML = cardSizes.innerHTML;
      }
    }
    if(event.target.closest('.mobile-quick-add-wrapper')){
      const cardProduct = event.target.closest(".product-card-wrapper");
      const size = event.target.matches('.card_size_option') ? event.target : event.target.closest('.card_size_option')
      if(size){
        const cardId = size.getAttribute('data-card-id')
        document.querySelector('.product-card-wrapper [data-card-id="'+cardId+'"]').click()
      }
       document.querySelector('.mobile-quick-add-wrapper').classList.add('hidden');
          document.querySelector('.mobile-quick-add').classList.remove('visible');
    }
  })



// ------------------------------------ similar Items ----------------------------
class similarProductItems extends HTMLElement {
    constructor() {
      super();
      this.grid = this.querySelector('.related-items-grid') || this;
      this.storefrontAccessToken = '763c38326c15b353813e59f5dd817a57';
    }

    connectedCallback() {
      this.render();
    }

 async fetchProductHandles() {
  const productType = this.dataset.productType;
  const color = this.dataset.color;  
  const priceSettings = this.dataset.productsPrice
  if (!productType) return [];

  let filterQuery = `product_type:"${productType}"`;

  let hasNextPage = true;
  let cursor = null;
  let allHandles = [];

  while (hasNextPage) {
    const query = `
     query getProductsByType($filterQuery: String!, $cursor: String) {
  products(first: 250, after: $cursor, query: $filterQuery) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        handle
        variants(first: 100) {
          edges {
            node {
              price {
                amount
                currencyCode
              }
              compareAtPrice {
                amount
                currencyCode
              }
              selectedOptions {
                name
                value
              }
              metafield(namespace: "custom", key: "filter_colour_group") {
                value
              }
            }
          }
        }
        metafield(namespace: "custom", key: "color_groups") {
          value
        }
      }
    }
  }
}

    `;

    const variables = {
      filterQuery,
      cursor: cursor || null,
    };

    try {
      const response = await fetch('/api/2024-04/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': this.storefrontAccessToken,
        },
        body: JSON.stringify({ query, variables }),
      });

      if (!response.ok) throw new Error('GraphQL request failed');
      const data = await response.json();
      if (data.errors) throw new Error(data.errors[0].message);

      const pageInfo = data.data.products.pageInfo;
      hasNextPage = pageInfo.hasNextPage;
      cursor = pageInfo.endCursor;
      let products = data.data.products.edges;
      const variantColorGroup = this.getAttribute('data-color-group');
      //  if (priceSettings && priceSettings === 'only_full_price') {
      //   products = products.filter((product) => {
      //     return product.node.variants.edges.every((variantEdge) => {
      //       const v = variantEdge.node;
      //       return !v.compareAtPrice.amount || parseFloat(v.compareAtPrice.amount) <= 0;
      //     });
      //   });
      // } else if(priceSettings && priceSettings === 'only_sale_price'){
      //   products = products.filter((product) => {
      //     return product.node.variants.edges.every((variantEdge) => {
      //       const v = variantEdge.node;
      //       return v.compareAtPrice.amount && parseFloat(v.compareAtPrice.amount) >= v.price;
      //     });
      //   }); 
      // }
      let filteredProducts = [];
      if (color) {
        products.forEach((product) => {
          const variants = product.node.variants.edges;

          // 🎯 Priority 1: Exact color match
          const hasExactColor = variants.some((variantEdge) => {
            const variant = variantEdge.node;
            return variant.selectedOptions.some(
              (option) =>
                option.name.toLowerCase() === 'color' &&
                option.value.toLowerCase() === color.toLowerCase()
            );
          });

          // 🎯 Priority 2: Variant color value contains the group value
          const hasColorContainingGroup =
            variantColorGroup &&
            variants.some((variantEdge) => {
              const variant = variantEdge.node;
              return variant.selectedOptions.some(
                (option) =>
                  option.name.toLowerCase() === 'color' &&
                  option.value.toLowerCase().includes(variantColorGroup.toLowerCase())
              );
            });

          // 🎯 Priority 3: Matching color group metafield
          const hasMatchingVariantGroup = variants.some((variantEdge) => {
            const groupVal = variantEdge.node.metafield?.value;
            if (!groupVal) return false;
            if (variantColorGroup) {
              return groupVal.toLowerCase().includes(variantColorGroup.toLowerCase());
            } else {
              return groupVal.toLowerCase().includes(color.toLowerCase());
            }
          });

          let priority = null;
          if (hasExactColor) {
            priority = 1;
          } else if (hasColorContainingGroup) {
            priority = 2;
          } else if (hasMatchingVariantGroup) {
            priority = 3;
          }

          if (priority) {
            filteredProducts.push({
              node: product.node,
              priority,
            });
          }
        }); 
        filteredProducts.sort((a, b) => a.priority - b.priority);

      } else {
        filteredProducts = products.map((p) => ({ node: p.node, priority: 3 }));
      }

      allHandles = allHandles.concat(
        filteredProducts.map((edge) => edge.node.handle)
      );
    } catch (error) {
      console.error('Error fetching product handles:', error);
      break;
    }
  }

  // Remove current product
  allHandles = allHandles.filter(
    (item) => item !== this.getAttribute('data-current-product')
  );
 
  return allHandles.slice(0, 20);
}



    buildUrl(handles) {
      const handlesString = handles.join(',');

      let url = `/collections/all?view=related-items&products=${handlesString}`;

      const params = new URLSearchParams({
        view: 'related-items',
        type: this.dataset.type || 'similar-items',
        color: this.dataset.color || '', 
        'color-group': this.dataset.colorGroup || '', 
        'section-id': this.dataset.sectionId || '',
        'show-slider': this.dataset.showSlider || 'false'
      });
      if (params.toString()) {
        url += '&' + params.toString();
      }

      return url;
    }

    async fetchProductsByHandles(handles) {
      if (handles.length === 0) return '';

      try {
        const url = this.buildUrl(handles);
        const response = await fetch(url);
        if (!response.ok) throw new Error('Failed to fetch related products');
        return await response.text();
      } catch (error) {
        console.error(error);
        throw error;
      }
    }

    async render() {
      try {
        this.classList.add('loading-products');
        const handles = await this.fetchProductHandles();

        if (handles.length === 0) {
          this.classList.remove('loading-products');
          this.classList.add('hidden');
          this.grid.innerHTML = '<p>No related products found.</p>';
          return;
        }

        const html = await this.fetchProductsByHandles(handles);
        this.grid.innerHTML = html; 
        if(this.grid?.querySelector('.grid__item')){
          this.classList.remove('hidden');
        } else{
          this.classList.add('hidden');
        }
        this.classList.remove('loading-products');
        document.querySelector('similar-product-items slider-component').resetPages();
      } catch (error) {
        console.error(error);
        this.classList.add('hidden');
        this.grid.innerHTML = '<p>Unable to load related products.</p>';
        this.classList.remove('loading-products');
      }
    }

    refresh() {
      this.render();
    }
  }
  customElements.define('similar-product-items', similarProductItems);

class relatedProductItems extends HTMLElement {
    constructor() {
      super();
      this.grid = this.querySelector('.related-items-grid') || this;
      this.storefrontAccessToken = '763c38326c15b353813e59f5dd817a57';
    }
    connectedCallback() {
      this.render();
    }
    shuffleArray(array) {
      const shuffled = [...array]; // Create a copy to avoid mutating original
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    }

 async fetchProductHandles() { 
  const productType = this.dataset.productType;
  const color = this.dataset.color; 
  const priceSettings = this.dataset.productsPrice
  let filterQuery = `NOT product_type:*Accessories*`;
  let hasNextPage = true;
  let cursor = null;
  let allHandles = [];

  while (hasNextPage) {
    const query = `
     query getProductsByType($filterQuery: String!, $cursor: String) {
        products(first: 250, after: $cursor, query: $filterQuery) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              handle
              productType
              variants(first: 100) {
                edges {
                  node {
                   price {
                    amount
                    currencyCode
                  }
                  compareAtPrice {
                    amount
                    currencyCode
                  }
                    selectedOptions {
                      name
                      value
                    }
                    metafield(namespace: "custom", key: "filter_colour_group") {
                      value
                    }
                  }
                }
              }
              metafield(namespace: "custom", key: "color_groups") {
                value
              }
            }
          }
        }
      }
    `;

    const variables = {
      filterQuery,
      cursor: cursor || null,
    };

    try {
      const response = await fetch('/api/2024-04/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': this.storefrontAccessToken,
        },
        body: JSON.stringify({ query, variables }),
      });

      if (!response.ok) throw new Error('GraphQL request failed');
      const data = await response.json();
      if (data.errors) throw new Error(data.errors[0].message);

      const pageInfo = data.data.products.pageInfo;
      hasNextPage = pageInfo.hasNextPage;
      cursor = pageInfo.endCursor;
      let  products = data.data.products.edges;
      const variantColorGroup = this.getAttribute('data-color-group');
      if (productType) {
        products = products.filter((product) => {
          const prodType = product.node.productType || '';
          return prodType.includes(productType) && !prodType.toLowerCase().includes('accessories') ;
        });
      }

      let filteredProducts = [];
      if (color) {
        products.forEach((product) => {
          const variants = product.node.variants.edges;
          const hasExactColor = variants.some((variantEdge) => {
            const variant = variantEdge.node;
            return variant.selectedOptions.some(
              (option) =>
                option.name.toLowerCase() === 'color' &&
                option.value.toLowerCase() === color.toLowerCase()
            );
          });
          const hasColorContainingGroup =
            variantColorGroup &&
            variants.some((variantEdge) => {
              const variant = variantEdge.node;
              return variant.selectedOptions.some(
                (option) =>
                  option.name.toLowerCase() === 'color' &&
                  option.value.toLowerCase().includes(variantColorGroup.toLowerCase())
              );
            });
          const hasMatchingVariantGroup = variants.some((variantEdge) => {
            const groupVal = variantEdge.node.metafield?.value;
            if (!groupVal) return false;
            if (variantColorGroup) {
              return groupVal.toLowerCase().includes(variantColorGroup.toLowerCase());
            } else {
              return groupVal.toLowerCase().includes(color.toLowerCase());
            }
          });

          let priority = null;
          if (hasExactColor) {
            priority = 1;
          } else if (hasColorContainingGroup) {
            priority = 2;
          } else if (hasMatchingVariantGroup) {
            priority = 3;
          }

          if (priority) {
            filteredProducts.push({
              node: product.node,
              priority,
            });
          }
        }); 
        const priorityGroups = {};
        filteredProducts.forEach(product => {
          if (!priorityGroups[product.priority]) {
            priorityGroups[product.priority] = [];
          }
          priorityGroups[product.priority].push(product);
        });
        Object.keys(priorityGroups).forEach(priority => {
          priorityGroups[priority] = this.shuffleArray(priorityGroups[priority]);
        });
        filteredProducts = [];
        [1, 2, 3].forEach(priority => {
          if (priorityGroups[priority]) {
            filteredProducts = filteredProducts.concat(priorityGroups[priority]);
          }
        });

      } else {
        filteredProducts = products.map((p) => ({ node: p.node, priority: 3 }));
        filteredProducts = this.shuffleArray(filteredProducts);
      }

      allHandles = allHandles.concat(
        filteredProducts.map((edge) => edge.node.handle)
      );
    } catch (error) {
      console.error('Error fetching product handles:', error);
      break;
    }
  }
  allHandles = allHandles.filter(
    (item) => item !== this.getAttribute('data-current-product')
  );
  allHandles = this.shuffleArray(allHandles);
 
  return allHandles.slice(0, 20);
}

    buildUrl(handles) {
      const handlesString = handles.join(',');

      let url = `/collections/all?view=related-items&products=${handlesString}`;

      const params = new URLSearchParams({
        view: 'related-items',
        type: this.dataset.type || 'related-items',
        color: this.dataset.color || '', 
        'color-group': this.dataset.colorGroup || '', 
        'section-id': this.dataset.sectionId || '',
        'show-slider': this.dataset.showSlider || 'false'
      });
      if (params.toString()) {
        url += '&' + params.toString();
      }

      return url;
    }

    async fetchProductsByHandles(handles) {
      if (handles.length === 0) return '';

      try {
        const url = this.buildUrl(handles);
        const response = await fetch(url);
        if (!response.ok) throw new Error('Failed to fetch related products');
        return await response.text();
      } catch (error) {
        console.error(error);
        throw error;
      }
    }

    async render() {
      try {
        this.classList.add('loading-products');
        const handles = await this.fetchProductHandles();

        if (handles.length === 0) {
          this.classList.remove('loading-products');
          this.classList.add('hidden');
          this.grid.innerHTML = '<p>No related products found.</p>';
          return;
        }

        const html = await this.fetchProductsByHandles(handles);
        this.grid.innerHTML = html; 
        if(this.grid?.querySelector('.grid__item')){
          this.classList.remove('hidden');
        } else{
          this.classList.add('hidden');
        }
        this.classList.remove('loading-products');
        document.querySelector('related-product-items slider-component').resetPages();
      } catch (error) {
        console.error(error);
        this.classList.add('hidden');
        this.grid.innerHTML = '<p>Unable to load related products.</p>';
        this.classList.remove('loading-products');
      }
    }

    refresh() {
      this.render();
    }
  }
  customElements.define('related-product-items', relatedProductItems);

  window.refreshSimilarProducts = function (newParams = {}) {
    const relatedProductElement = document.querySelector('similar-product-items');
    const recommendedProductElement = document.querySelector('related-product-items');
    if(relatedProductElement) relatedProductElement.refresh();
    if(recommendedProductElement) recommendedProductElement.refresh()
  };

// --------------------------Cart recommendations ----------------
// --------------------------Cart recommendations ----------------
class CartProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.grid = this.querySelector('.slider ul') || this.querySelector('.grid');
      this.loader = this.querySelector('.cart-recommendations-loader');
      this.wrapper = this.querySelector('.cart-recommendations-wrapper');
      this.storefrontAccessToken = '763c38326c15b353813e59f5dd817a57';
      this.maxProducts = 20;
    }

    connectedCallback() {
      // this.render();
    }
 
    shuffleArray(array) {
      const shuffled = [...array];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    }
 
    getRecommendationTypes() {
      const productType = this.dataset.productType;
      if (!window.cartRecomendationsTypes || !productType) {
        return [];
      }
 
      const recommendedTypes = window.cartRecomendationsTypes[productType];
      return recommendedTypes || [];
    }
 
    async fetchProductsByType(productType) {
      const color = this.dataset.color;
      const colorGroup = this.dataset.colorGroup;
      const filterColor = this.dataset.filterColor;
      let filterQuery = `product_type:"${productType}"`;

      let hasNextPage = true;
      let cursor = null;
      let allProducts = [];

      // Fetch more products to ensure we have enough after filtering
      while (hasNextPage && allProducts.length < 250) {
        const query = `
          query getProductsByType($filterQuery: String!, $cursor: String) {
            products(first: 250, after: $cursor, query: $filterQuery) {
              pageInfo {
                hasNextPage
                endCursor
              }
              edges {
                node {
                  handle
                  productType
                  variants(first: 100) {
                    edges {
                      node {
                        price {
                          amount
                          currencyCode
                        }
                        compareAtPrice {
                          amount
                          currencyCode
                        }
                        selectedOptions {
                          name
                          value
                        }
                        metafield(namespace: "custom", key: "filter_colour_group") {
                          value
                        }
                        filterColor: metafield(namespace: "custom", key: "filter_color") {
                          value
                        }
                      }
                    }
                  }
                  metafield(namespace: "custom", key: "color_groups") {
                    value
                    key
                  }
                }
              }
            }
          }
        `;

        const variables = {
          filterQuery,
          cursor: cursor || null,
        };

        try {
          const response = await fetch('/api/2024-04/graphql.json', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': this.storefrontAccessToken,
            },
            body: JSON.stringify({ query, variables }),
          });

          if (!response.ok) throw new Error('GraphQL request failed');
          const data = await response.json();
          if (data.errors) throw new Error(data.errors[0].message);

          const pageInfo = data.data.products.pageInfo;
          hasNextPage = pageInfo.hasNextPage;
          cursor = pageInfo.endCursor;
          
          let products = data.data.products.edges; 
          
          // Filter and prioritize products
          if (color) {
            const filteredProducts = [];
            
            products.forEach((product) => {
              const variants = product.node.variants.edges;
 
              const hasExactColor = variants.some((variantEdge) => {
                const variant = variantEdge.node;
                return variant.selectedOptions.some(
                  (option) =>
                    option.name.toLowerCase() === 'color' &&
                    option.value.toLowerCase() === color.toLowerCase()
                );
              });
              const hasIncludingColor = variants.some((variantEdge) => {
                const variant = variantEdge.node;
                return variant.selectedOptions.some(
                  (option) =>
                    option.name.toLowerCase() === 'color' &&
                    option.value.toLowerCase().includes(color.toLowerCase())
                );
              });
 
              const hasColorContainingGroup =
                colorGroup &&
                variants.some((variantEdge) => {
                  const variant = variantEdge.node;
                  return variant.selectedOptions.some(
                    (option) =>
                      option.name.toLowerCase() === 'color' &&
                      option.value.toLowerCase() ===  colorGroup.toLowerCase()
                  );
                });
 
              const hasColorContainingFilterColor =
                colorGroup &&
                variants.some((variantEdge) => {
                  const variant = variantEdge.node;
                  return variant.selectedOptions.some(
                    (option) =>
                      option.name.toLowerCase() === 'color' &&
                      option.value.toLowerCase().includes(filterColor.toLowerCase())
                  );
                });
 
              // Check variant filter_colour_group metafield
              const hasMatchingVariantGroup = variants.some((variantEdge) => {
                const groupVal = variantEdge.node.metafield?.value;
                if (!groupVal) return false;
                if (colorGroup) {
                  return groupVal.toLowerCase() ===  colorGroup.toLowerCase();
                } else {
                  return groupVal.toLowerCase() ===  color.toLowerCase();
                }
              });

              // Check variant filter_color metafield
              const hasMatchingFilterColor = variants.some((variantEdge) => {
                const variant = variantEdge.node;
                const filterColorVal = variant.metafield?.value;
                if (!filterColorVal) return false;
                if (colorGroup) {
                  return filterColorVal.toLowerCase() ===  filterColor.toLowerCase();
                } else {
                  return filterColorVal.toLowerCase() ===  color.toLowerCase();
                }
              });

              // Check product-level color_groups metafield
              // const productColorGroups = product.node.metafield?.value;
              // const hasMatchingProductColorGroup = productColorGroups && 
              //   (colorGroup 
              //     ? productColorGroups.toLowerCase() === colorGroup.toLowerCase()
              //     : productColorGroups.toLowerCase() === color.toLowerCase()
              //   );

              let priority = null;
              if (hasExactColor) { 
                priority = 1;
              } else if (hasMatchingFilterColor) {
                priority = 2;
              } else if (hasMatchingFilterColor) {
              priority = 3;
              } else if (hasColorContainingGroup) {
                priority = 4;
              } else if (hasColorContainingFilterColor) {
                priority = 5; 
              } else if (hasMatchingVariantGroup) {
                priority = 6;
              } 

              if (priority) {
                filteredProducts.push({
                  node: product.node,
                  priority,
                  productType
                });
              }
            });
 
            products = filteredProducts;
          } else {
            products = products.map(p => ({ 
              node: p.node, 
              priority: 6,
              productType 
            }));
          }

          allProducts = allProducts.concat(products);

        } catch (error) {
          console.error(`Error fetching products for type ${productType}:`, error);
          break;
        }
      }

      return allProducts;
    }
 
    async fetchAllRecommendedProducts() {
      const recommendationTypes = this.getRecommendationTypes();
      if (recommendationTypes.length === 0) {
        return [];
      }

      // Fetch all products from all types concurrently
      const productPromises = recommendationTypes.map(productType => 
        this.fetchProductsByType(productType)
      );

      let allProducts = [];
      try {
        const results = await Promise.all(productPromises);
        allProducts = results.flat();
      } catch (error) {
        console.error('Error fetching products:', error);
        return [];
      }

      // Filter out current product
      const currentProduct = this.getAttribute('data-current-product');
      allProducts = allProducts.filter(p => p.node.handle !== currentProduct);

      // Group by priority across ALL types
      const priorityGroups = { 1: [], 2: [], 3: [], 4: [], 5: [], 6: [] };
      allProducts.forEach(product => {
        if (priorityGroups[product.priority]) {
          priorityGroups[product.priority].push(product);
        }
      });

      // Optional: Shuffle within each priority group for variety
      // Object.keys(priorityGroups).forEach(priority => {
      //   priorityGroups[priority] = this.shuffleArray(priorityGroups[priority]);
      // });

      // Merge: First all priority 1, then priority 2, 3, 4
      let finalProducts = [];
      [1, 2, 3, 4, 5, 6].forEach(priority => {
        if (priorityGroups[priority]) {
          finalProducts = finalProducts.concat(priorityGroups[priority]);
        }
      });

      // Take only the handles we need
      const handles = finalProducts
        .slice(0, this.maxProducts) ;

   
      return finalProducts;
    }
 
    buildUrl(handles) {
      const handlesString = handles.join(',');
      let url = `/collections/all?view=related-items&products=${handlesString}`;

      const params = new URLSearchParams({
        view: 'related-items',
        type: this.dataset.type || 'related-items',
        color: this.dataset.color || '', 
        'color-group': this.dataset.colorGroup || '', 
        'section-id': this.dataset.sectionId || '',
        'show-slider': this.dataset.showSlider || 'false'
      });

      if (params.toString()) {
        url += '&' + params.toString();
      }

      return url;
    }
 
    async fetchProductsByHandles(handles) {
      if (handles.length === 0) return '';

      try {
        const url = this.buildUrl(handles);
        const response = await fetch(url);
        if (!response.ok) throw new Error('Failed to fetch related products');
        return await response.text();
      } catch (error) {
        console.error('Error fetching product HTML:', error);
        throw error;
      }
    }
 
    showLoader() {
      if (this.loader) this.loader.style.display = 'flex';
      if (this.wrapper) this.wrapper.style.display = 'none';
      this.classList.remove('hidden');
    }

    hideLoader() {
      if (this.loader) this.loader.style.display = 'none';
      if (this.wrapper) this.wrapper.style.display = 'block';
    }
 
    async render() {
      try {
        this.showLoader();
         
        const allProductsData = await this.fetchAllRecommendedProducts();

        if (allProductsData.length === 0) {
          this.classList.add('hidden');
          if (this.grid) this.grid.innerHTML = '<p>No related products found.</p>';
          this.hideLoader();
          return;
        }
      
        const handles = allProductsData.map(p => p.node.handle);
        const html = await this.fetchProductsByHandles(handles);
        
        // Create a temporary container to parse the HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        
        // Get all product items from the HTML
        const productItems = tempDiv.querySelectorAll('.grid__item[d-handle], li[d-handle]');
        
        // Count exact match products (priority 1) from the HTML results
        const exactMatchHandles = allProductsData
          .filter(p => p.priority === 1)
          .map(p => p.node.handle);
        
        let exactMatchCount = 0;
        productItems.forEach(item => {
          const itemHandle = item.getAttribute('d-handle');
          if (exactMatchHandles.includes(itemHandle)) {
            exactMatchCount++;
          }
        });
        
     
        
        // If we have more than 3 exact matches, filter to show only exact matches
        if (exactMatchCount >= 3) {
          productItems.forEach(item => {
            const itemHandle = item.getAttribute('d-handle');
            const isExactMatch = exactMatchHandles.some(handle => handle === itemHandle);
            if (!isExactMatch) {
              item.remove();
            }
          });
          
          if (this.grid) this.grid.innerHTML = tempDiv.innerHTML;
        } else {
          // Show all products as originally fetched
          if (this.grid){
          this.grid.innerHTML = html;
          }
          this.grid.querySelectorAll('.grid__item:has(> [sold-out-product])')?.forEach(item => item.remove())
        }
 
        if (this.grid?.querySelector('.grid__item') || this.grid?.querySelector('li')) {
          this.classList.remove('hidden');
        } else {
          this.classList.add('hidden');
        }

        this.hideLoader();
 
        const sliderComponent = this.querySelector('slider-component');
        if (sliderComponent && sliderComponent.resetPages) {
          sliderComponent.resetPages();
        }

      } catch (error) {
        console.error('Error rendering cart recommendations:', error);
        this.classList.add('hidden');
        if (this.grid) this.grid.innerHTML = '<p>Unable to load related products.</p>';
        this.hideLoader();
      }
    }
 
    refresh() {
      this.render();
    }
  } 
  customElements.define('cart-product-recommendations', CartProductRecommendations);